import firebase from "firebase";
import { DELETED_STATUS, languageCodes, batchSize } from "../../../src/config/index";
import {
  addPunch,
  updatePunch,
  getPunchData,
  getNewWorkerPunchRecords,
  setLastPunch,
  createPunch,
  getWeekNumber,
  setPunchHistory
} from "../../services";
import {
  workersRef,
  punchesRef,
  countriesRef,
  collectionRef,
  collectionGroup,
  CL_JOB_FAMILIES,
  CL_ACTIVITY_GROUPS,
  CL_LOCATIONS,
  CL_COUNTRIES,
  LOCATIONS_DEV,
  storageRef,
  CL_EXCEPTIONS,
  ASC,
  // collectionGroup,
} from "../../services/firebase";

import {
  DEVICE_DETAILS,
  MISSED_CLOCK_OUT,
  CLOCK_OUT,
} from "../../config/index";
import { categoryPunch } from "../../pages/Punch/constants";
import { getPunch } from "../../utils/punch";
import { properCase,properCamelCase, properCamelCaseNew } from "utils";
import moment from "moment";
import { dateConfig } from "config";
const db = firebase.firestore();
// This function is used for different BG color for different timesheet activities
export const timesheetActivitiesBGColor = (group) => {
  // console.log("this is group ", group);
  if (group.value == "Transactional" || group.value == "transactional") {
    return "#1B75BC";
  }
  if (
    group.value == "Non-Transactional" ||
    group.value == "non-transactional"
  ) {
    return "#00A88E";
  }
  if (group.value == "Project" || group.value == "project") {
    return "#6DCFF6";
  }
  if (group.value == "Meal" || group.value == "meal") {
    return "#58595B";
  }
  if (group.value == "Building Moves" || group.value == "building moves") {
    return "#3C5772";
  }
  if (group.value == "Leave" || group.value == "leave") {
    return "#58595B";
  }
  return "#FFFFFF";
};

export const getNewId = () => {
  return db.collection("punches").doc().id;
};

const normalizeFloat = (value) => {
  return parseFloat(value ? value : "0");
};

export const fixDecimal = (n, decimal = 2) => {
  return n.toFixed(decimal);
};

export const getTotals = (data) => {
  // console.log("Data", data);
  const initialTotals = Array.from(Array(7)).map(() => ({ hours: 0 }));
  const totals = {};
  let totalHours = 0;
  for (let i = 0; i < initialTotals.length; ++i) {
    totals[`day${i + 1}`] = initialTotals[i];
  }
  if (!data) return { totals, totalHours };
  for (let record of data) {
    totals["day1"].hours += normalizeFloat(record.day1);
    totals["day2"].hours += normalizeFloat(record.day2);
    totals["day3"].hours += normalizeFloat(record.day3);
    totals["day4"].hours += normalizeFloat(record.day4);
    totals["day5"].hours += normalizeFloat(record.day5);
    totals["day6"].hours += normalizeFloat(record.day6);
    totals["day7"].hours += normalizeFloat(record.day7);
  }

  for (let i = 0; i < 7; ++i) {
    const index = i + 1;
    totalHours += totals[`day${index}`].hours;
    totals[`day${index}`].hours = fixDecimal(totals[`day${index}`].hours);
  }
  // totalHours = fixDecimal(totalHours);
  // console.log("New", totals);
  return { totals, totalHours };
  // return totals;
};

export const createSplitPunches = (data, punchId, loggedInSupervisor,punch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const {
        group,
        startTime,
        endTime,
        districtId,
        buildingId,
        jobfamily,
        project,
        freeFormText,
        exceptionName,
        jobProjectInfo,
        customerSite,
        isException,
        projectDetails,
      } = data;

      // console.log("data:", data);
      
      let finalPunchArray = [];
      let finalMap = {};
      let resultArray = [];
      let timeStamp = new Date();
      const actionTS = new Date().toISOString();

      if (punch) {
        const startDateTime = moment(new Date(startTime)).format(
          dateConfig.format4
        );
        const endDateTime = moment(new Date(endTime)).format(
          dateConfig.format4
        );
        // console.log("startDateTime:", startDateTime);
        finalMap[punchId] = punch;
        //resultArray.push({ ...punch });
        finalPunchArray.push(punchId);
        const inTime = moment(startTime).format(dateConfig.format7);
        const outTime = moment(endTime).format(dateConfig.format7);

        const in_TS = new Date(inTime).toISOString();
        const out_TS = new Date(outTime).toISOString();

        // console.log("in_TS:", in_TS);

        const activityName = CLOCK_OUT;

        const newPunch = getPunch(
          group?.value,
          activityName,
          buildingId,
          districtId,
          customerSite,
          exceptionName,
          isException,
          jobfamily,
          project ? project : freeFormText,
          "new",
          punch.version,
          punch.workerId,
          actionTS,
          in_TS,
          startDateTime,
          out_TS,
          endDateTime,
          loggedInSupervisor,
          DEVICE_DETAILS,
          categoryPunch,
          projectDetails,
        );
        console.log("If 7......", newPunch);
        await createPunch(newPunch, false)
          .then((newPunchId) => {
            console.log("punch added ", newPunchId);
            finalPunchArray.push(newPunchId);
          })
          .catch((error) => {
            console.log(error);
            reject(new Error(error));
          });
        punch.inLocalTS = moment(punch.inLocalTS).format(dateConfig.format7);
        const punch_inLocalTS = moment(punch.inLocalTS).format(
          dateConfig.format4
        );
        punch.outLocalTS =
          punch.outLocalTS != ""
            ? moment(punch.outLocalTS).format(dateConfig.format7)
            : "";
        const punch_outLocalTS =
          punch.outLocalTS != ""
            ? moment(punch.outLocalTS).format(dateConfig.format4)
            : "";

        if (
          (inTime > punch.inLocalTS && punch.outLocalTS == "") ||
          (punch.outLocalTS != "" &&
            inTime > punch.inLocalTS &&
            outTime < punch.outLocalTS)
        ) {
          const outTS = new Date(startDateTime).toISOString();

          const firstPunch = getPunch(
            punch.activityGroup,
            activityName,
            punch.buildingId,
            punch.districtId,
            punch.customerSite,
            punch.exceptionName,
            punch.isException,
            punch.jobName,
            punch.jobProjectInfo,
            "edit",
            punch.version,
            punch.workerId,
            actionTS,
            punch.inTS,
            punch_inLocalTS,
            outTS,
            startDateTime,
            loggedInSupervisor,
            DEVICE_DETAILS,
            categoryPunch,
            punch.projectDetails
          );
          console.log("firstupdated:", firstPunch);
          console.log("punch.id:", punchId);
          await updatePunch(punchId, firstPunch)
            .then((data) => {
              console.log("success on update punch1", data);
            })
            .catch((error) => {
              console.log(error);
              reject(new Error(error));
            });
        }

        if (
          outTime > punch.inLocalTS &&
          punch.outLocalTS != "" &&
          outTime < punch.outLocalTS &&
          inTime < punch.inLocalTS
        ) {
          console.log("If 2......");
          const inTS = new Date(endDateTime).toISOString();
          const secondPunch = getPunch(
            punch.activityGroup,
            punch.activityName,
            punch.buildingId,
            punch.districtId,
            punch.customerSite,
            exceptionName,
            exceptionName ? true : false,
            punch.jobName,
            punch.jobProjectInfo,
            "edit",
            punch.version,
            punch.workerId,
            actionTS,
            inTS,
            endDateTime,
            punch.outTS,
            punch_outLocalTS,
            loggedInSupervisor,
            DEVICE_DETAILS,
            categoryPunch,
            punch.projectDetails
          );
          console.log("secondPunch:", secondPunch);
          await updatePunch(punchId, secondPunch)
            .then((data) => {
              console.log("success on update punch2", data);
            })
            .catch((error) => {
              console.log(error);
              reject(new Error(error));
            });
        }

        if (
          punch.outLocalTS != "" &&
          inTime > punch.inLocalTS &&
          outTime < punch.outLocalTS
        ) {
          console.log("If 5......");
          const inTS = new Date(endDateTime).toISOString();
          const fifthPunch = getPunch(
            punch.activityGroup,
            activityName,
            punch.buildingId,
            punch.districtId,
            punch.customerSite,
            exceptionName,
            exceptionName ? true : false,
            punch.jobName,
            punch.jobProjectInfo,
            "new",
            punch.version,
            punch.workerId,
            actionTS,
            inTS,
            endDateTime,
            punch.outTS,
            punch_outLocalTS,
            loggedInSupervisor,
            DEVICE_DETAILS,
            categoryPunch,
            punch.projectDetails
          );
          console.log("fifthPunch:", fifthPunch);
          await createPunch(fifthPunch, false)
            .then((newPunchId) => {
              console.log("punch added 5", newPunchId);
              finalPunchArray.push(newPunchId);
            })
            .catch((error) => {
              console.log(error);
              reject(new Error(error));
            });
        }
        if (
          punch.outLocalTS == "" &&
          inTime > punch.inLocalTS &&
          !(new Date(timeStamp).getTime() == new Date(outTime).getTime())
        ) {
          console.log("If 6......");
          const inTS = new Date(endDateTime).toISOString();
          const outTS = new Date(timeStamp).toISOString();
          const outLocalTS = moment(timeStamp).format(dateConfig.format4);
          const activityName = CLOCK_OUT;
          const sixthPunch = getPunch(
            punch.activityGroup,
            activityName,
            punch.buildingId,
            punch.districtId,
            punch.customerSite,
            exceptionName,
            exceptionName ? true : false,
            punch.jobName,
            punch.jobProjectInfo,
            "new",
            punch.version,
            punch.workerId,
            actionTS,
            inTS,
            endDateTime,
            outTS,
            outLocalTS,
            loggedInSupervisor,
            DEVICE_DETAILS,
            categoryPunch,
            punch.projectDetails
          );
          console.log("sixthPunch:", sixthPunch);

          await createPunch(sixthPunch, false)
            .then((newPunchId) => {
              console.log("punch added 6", newPunchId);
              finalPunchArray.push(newPunchId);
            })
            .catch((error) => {
              console.log(error);
              reject(new Error(error));
            });
        }

        if (
          punch.outLocalTS !== "" &&
          (inTime < punch.inLocalTS || inTime == punch.inLocalTS) &&
          (punch.outLocalTS < outTime || punch.outLocalTS == outTime)
        ) {
          console.log("Deleting Punch 8......");
          const status = "deleted";
          const eightPunch = getPunch(
            punch.activityGroup,
            punch.activityName,
            punch.buildingId,
            punch.districtId,
            punch.customerSite,
            punch.exceptionName,
            punch.isException,
            punch.jobName,
            punch.jobProjectInfo,
            status,
            punch.version,
            punch.workerId,
            actionTS,
            punch.inTS,
            punch_inLocalTS,
            punch.outTS,
            punch_outLocalTS,
            loggedInSupervisor,
            DEVICE_DETAILS,
            categoryPunch,
            punch.projectDetails
          );
          console.log("EightPunch:", eightPunch);
          await updatePunch(punchId, eightPunch)
            .then((data) => {
              console.log("success on update punch4", data);
            })
            .catch((error) => {
              console.log(error);
              reject(new Error(error));
            });
        }

        if (
          punch.outLocalTS !== "" &&
          inTime == punch.inLocalTS &&
          punch.outLocalTS > outTime
        ) {
          console.log("9th punch called......");
          const ninthPunch = getPunch(
            punch.activityGroup,
            punch.activityName,
            punch.buildingId,
            punch.districtId,
            punch.customerSite,
            punch.exceptionName,
            punch.isException,
            punch.jobName,
            punch.jobProjectInfo,
            "edit",
            punch.version,
            punch.workerId,
            actionTS,
            out_TS,
            endDateTime,
            punch.outTS,
            punch_outLocalTS,
            loggedInSupervisor,
            DEVICE_DETAILS,
            categoryPunch,
            punch.projectDetails
          );

          await updatePunch(punchId, ninthPunch)
            .then((data) => {
              console.log("success on update punch9", data);
            })
            .catch((error) => {
              console.log(error);
              reject(new Error(error));
            });
        }

        if (
          punch.outLocalTS !== "" &&
          outTime == punch.outLocalTS &&
          punch.inLocalTS < inTime
        ) {
          console.log("10th punch called......");
          const tenthPunch = getPunch(
            punch.activityGroup,
            punch.activityName,
            punch.buildingId,
            punch.districtId,
            punch.customerSite,
            punch.exceptionName,
            punch.isException,
            punch.jobName,
            punch.jobProjectInfo,
            "edit",
            punch.version,
            punch.workerId,
            actionTS,
            punch.inTS,
            punch_inLocalTS,
            in_TS,
            startDateTime,
            loggedInSupervisor,
            DEVICE_DETAILS,
            categoryPunch,
            punch.projectDetails
          );

          await updatePunch(punchId, tenthPunch)
            .then((data) => {
              console.log("success on update punch10", data);
            })
            .catch((error) => {
              console.log(error);
              reject(new Error(error));
            });
        }
        for (let i = 0; i < finalPunchArray.length; i++) {
          let eachPunchId = finalPunchArray[i];
          await punchesRef()
            .doc(eachPunchId)
            .get()
            .then(async (data) => {
              if (data.exists) {
                if (data.status != "deleted") {
                  let punchRecord = { ...data.data(), punchId: data.id };
                  finalMap[punchRecord.punchId] = punchRecord;
                  resultArray.push({ ...punchRecord });
                }
              }
            })
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        }
      } else reject("No punch data found:");
      //console.log("this is utils split final map ", finalMap);
      console.log("this is utils split result array ", resultArray);
      resolve(resultArray);
    } catch (error) {
      console.error("approve save error", error);
      reject(error);
    }
  });
};

export const getErrors = (errors, index, field) => {
  // return false;
  if (!errors) return "";
  if (!errors[index]) return "";
  if (!errors[index][field]) return "";
  // return errors[index][field];
  return true;
};

export const getWeekError = (errors, field) => {
  if (!errors) return false;
  if (!errors[field]) return false;
  return errors[field];
};

export const getActivityGroupByLanguage = (language, activityGroups) => {
  // return activityGroups[language];
  const allActivityGroups = activityGroups[language];
  if (allActivityGroups !== undefined) {
    return allActivityGroups;
  } else {
    return activityGroups[languageCodes.english];
  }
};

export const getJobFamiliesByLanguage = (language, jobFamilies) => {
  // console.log('all job families', jobFamilies)
  const allJobFamilies = jobFamilies[language];
  if (allJobFamilies !== undefined) {
    return allJobFamilies;
  } else {
    return jobFamilies[languageCodes.english];
  }
};

export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

const isObject = (object) => {
  return object != null && typeof object === "object";
};

export const prepareForCalendar = (activities) => {
  if (!Array.isArray(activities)) return [];
  return activities.map((activity) => {
    const incomplete = activity.status === "new" && !activity.outLocalTS;
    console.log("this is activity issue ", activity);
    return {
      id: activity.id,
      title: activity.activityGroup,
      start: moment(activity.inLocalTS).toDate(),
      end: incomplete
        ? getCurrentTimeForDate(activity.inLocalTS)
        : moment(activity.outLocalTS).toDate(),
      editable: true,
      overlap: false,
      extendedProps: {
        ...activity,
        group: {
          label: activity.activityGroup,
          value: activity.activityGroup.toLowerCase(),
        },
      },

      backgroundColor: timesheetActivitiesBGColor({
        value: activity.activityGroup,
        label: activity.activityGroup,
      }),
      borderColor: "#fff",
      textColor: "#000000",
    };
  });
};

export const getWorkerName = (worker) => {
  if (!worker) return "";
  let name = worker.firstName;
  if (worker.lastName) name = `${name} ${worker.lastName}`;
  return `${name} (${worker.workerId})`;
};

export const getCurrentTimeForDate = (start) => {
  const now = moment();
  if (moment(start).isAfter(now)) {
    return moment(start).add(1, "minute").toDate();
  }
  return now.toDate();
  // const timeM = moment().format("HH:mm");
  // const time = moment(timeM, "HH:mm");
  // const date = moment(start).format("yyyy-MM-DD");
  // let mom = moment(date);
  // mom.set({
  //   hour: time.get("hour"),
  //   minute: time.get("minute"),
  //   second: time.get("second"),
  // });
  // return mom.toDate();
};

export const isApproveEnabled = (punches, selectedDate) => {
  // console.log(
  //   "limit test 1 selectedDate",
  //   punches,
  //   selectedDate,
  //   moment(new Date()).startOf("week").subtract(2, "weeks")
  // );

  let selectedDateWeekNumber = getWeekNumber(selectedDate);

  let filteredPunches = punches.filter((item) => {
    return item.extendedProps.weekNumber === selectedDateWeekNumber;
  });
  console.log("filtered punches", filteredPunches);
  let incomplete = 0;
  let pending = 0;
  if (filteredPunches.length == 0) {
    console.log("incom return false due to zero length");
    return [false, incomplete];
  }
  //selected date is in eligible range enable approve button

  if (selectedDate >= moment(new Date()).startOf("week").subtract(2, "weeks")) {
    console.log("test 1 date selection");
    for (let punch of filteredPunches) {
      //find any incomplete punch
      if (
        (punch.extendedProps.status === "new" ||
          punch.extendedProps.status === "edit") &&
        !punch.extendedProps.outLocalTS
      )
        incomplete++;
      //find any pending punch
      if (
        (punch.extendedProps.status === "new" ||
          punch.extendedProps.status === "edit" ||
          punch.extendedProps.status === "auto completed" ||
          punch.extendedProps.status === "auto adjusted") &&
        punch.extendedProps.outLocalTS
      )
        pending++;
    }
    //console.log("incomplete and pending count", incomplete, pending);
    if (pending > 0) {
      console.log("incomplete and pending count", incomplete, pending);

      return [true, incomplete];
    }
  }
  return [false, incomplete];
};

export const approvePunches = (
  punches,
  selectedWorker,
  selectedDate,
  loggedInSupervisor
) => {
  let docs = [];
  let filterPreviousPunches = [];
  const selectedWeek = getWeekNumber(selectedDate);
  filterPreviousPunches = punches.filter((item) => {
    console.log('selectedWeek:', selectedWeek);
    return (item.extendedProps.weekNumber) === selectedWeek;
  });
  
  let inprogressPunches = [];
  inprogressPunches = filterPreviousPunches.filter((item) => {
    return item.extendedProps.outLocalTS === "";
  });
  let filteredPunches = filterPreviousPunches.filter((item) => {
    return item.extendedProps.outLocalTS != "" && item.extendedProps.status !='approved';
  });
  console.log('filteredPunches:', filteredPunches);
  for (let punch of filteredPunches) {
    docs = [...docs, punch.id];
  }
  console.log("selected worker and docs", selectedWorker, docs);

  return new Promise(async (resolve, reject) => {
    try {
      let inProgressDays = [];
      for (let i = 0; i < docs.length; i++) {
        const punchRef = db.collection("punches").doc(docs[i]);
        await punchRef
          .get()
          .then(async (punchDataDoc) => {
            var  punchData = punchDataDoc.data();
            punchData.actionBy = loggedInSupervisor;
            punchData.actionTS = new Date().toISOString();
            punchData.status = "approved";
            await setPunchHistory(punchDataDoc.id, punchDataDoc.data());
            await punchRef.update(punchData);
            // await updatePunch(docs[i], punchData)
            //   .then(async (result) => {})
            //   .catch((error) => {
            //     console.log(error);
            //   });
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      }

      let timesheetStatus = "approved";
      let inProgressPunchesFound = false;
      if (inprogressPunches.length > 0) {
        timesheetStatus = "inProgress";
        const dayName = moment(inprogressPunches[0].extendedProps.inLocalTS)
          .format("dddd")
          .toString();
        inProgressDays.push(dayName);
        inProgressPunchesFound = true;
      }
      let data = {
        timesheetStatus: timesheetStatus,
        inProgressDays: inProgressDays,
        actionBy: loggedInSupervisor,
      };
      await updateTimesheetDocument(
        selectedWeek + "-" + selectedWorker.workerId,
        data
      )
        .then((data) => {
          console.log("result timesheet:", data);
          resolve([inProgressPunchesFound]);
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      console.error("approve save error", error);
      reject(error);
    }
  });
};

export const updateTimesheetDocument = (docId, dataToUpdate) => {
  const {
    timesheetStatus,
    actionBy,
    actionTS,
    activities,
    dayTotals,
    inProgressDays,
  } = dataToUpdate;
  console.log("dataToUpdate:", dataToUpdate);
  // console.log("docId:", docId);
  let isForApproval = false;
  if (timesheetStatus && timesheetStatus === "approved") {
    isForApproval = true;
  }
  // console.log("isForApproval:", isForApproval);
  return new Promise((resolve, reject) => {
    try {
      const timesheetRef = db.collection("timesheets").doc(docId);

      timesheetRef
        .get()
        .then((document) => {
          const data = document.data();
          const jobFamilyDetailMap={};
          // console.log("data:", data);
          if (data) {
            const actGrpDetailMap ={};
            data.actionTS = new Date().toISOString();
            if (timesheetStatus) data.timesheetStatus = timesheetStatus;
            if (actionBy) data.actionBy = actionBy;
            if (actionTS) data.actionTS = actionTS;
            if (activities) data.activities = activities;
            if (dayTotals) data.dayTotals = dayTotals;

            const dayTotalsData = data.dayTotals;
              let pendingPunches = data.pendingPunches;
              let approvedPunches = data.approvedPunches;

            if (isForApproval === true) {
              for (let eachDay in dayTotalsData) {
                if (
                  Object.prototype.hasOwnProperty.call(dayTotalsData, eachDay)
                ) {
                  const eachDayData = dayTotalsData[eachDay];
                  eachDayData.status = "approved";
                }
              }

              if (pendingPunches && Object.keys(pendingPunches).length > 0) {
                for (let eachPunchId in pendingPunches) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      pendingPunches,
                      eachPunchId
                    )
                  ) {
                    if (approvedPunches && !approvedPunches[eachPunchId]) {
                      approvedPunches[eachPunchId] =
                        pendingPunches[eachPunchId];
                      delete pendingPunches[eachPunchId];
                    }
                  }
                }
              }
            } else if (inProgressDays && inProgressDays.length > 0) {
              //  inProgressDays = inProgressDays.filter((c, index) => {
              //    return inProgressDays.indexOf(c) === index;
              // });
              for (let eachDay in dayTotalsData) {
                if (
                  Object.prototype.hasOwnProperty.call(dayTotalsData, eachDay)
                ) {
                  if (!inProgressDays.includes(eachDay)) {
                    const eachDayData = dayTotalsData[eachDay];
                    eachDayData.status = "approved";
                  }
                }
              }
              for (let eachPunchId in pendingPunches) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    pendingPunches,
                    eachPunchId
                  )
                ) {
                  if (approvedPunches && !approvedPunches[eachPunchId]) {
                      const duration = pendingPunches[eachPunchId].duration;
                    if (duration != 0) {
                      approvedPunches[eachPunchId] =
                        pendingPunches[eachPunchId];
                      delete pendingPunches[eachPunchId];
                    }
                  }
                }
              }
            }

            if (Object.keys(pendingPunches).length > 0) {
              for (const punchId in pendingPunches) {
                if (Object.prototype.hasOwnProperty
                    .call(pendingPunches, punchId)) {
                  let actGroup = pendingPunches[punchId]
                      .activityGroup;
                      actGroup =  properCamelCase(actGroup);
                  const duration = pendingPunches[punchId].duration;
                  let jobFamily = pendingPunches[punchId].jobFamily;
                  const jobFamilyActGrpMap={};
                  if (jobFamily) {
                    jobFamily = properCamelCaseNew(jobFamily);
                    if ( jobFamilyDetailMap[jobFamily]) {
                      const jobFamilyDetails =
                              {...jobFamilyDetailMap[jobFamily]};
                      if (jobFamilyDetails[actGroup]) {
                        jobFamilyDetails[actGroup] += duration;
                        jobFamilyDetailMap[jobFamily] =
                                 jobFamilyDetails;
                      } else {
                        jobFamilyDetails[actGroup] = duration;
                        jobFamilyDetailMap[jobFamily] =
                                 jobFamilyDetails;
                      }
                    } else {
                      jobFamilyActGrpMap[actGroup] = duration;
                      jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                    }
                  }

                  if (actGroup !='meal') {
                    if ( actGrpDetailMap[actGroup]) {
                      actGrpDetailMap[actGroup] +=duration;
                    } else {
                      actGrpDetailMap[actGroup] =duration;
                    }
                  }
                }
              }
            }

            if (Object.keys(approvedPunches).length > 0) {
              for (const punchId in approvedPunches) {
                if (Object.prototype.hasOwnProperty
                    .call(approvedPunches, punchId)) {
                      let actGroup = approvedPunches[punchId]
                      .activityGroup;
                      actGroup =  properCamelCase(actGroup);
                  const duration = approvedPunches[punchId].duration;
                  let jobFamily = approvedPunches[punchId].jobFamily;
                  const jobFamilyActGrpMap={};
                  if (jobFamily) {
                    jobFamily = properCamelCaseNew(jobFamily);
                    if ( jobFamilyDetailMap[jobFamily]) {
                      const jobFamilyDetails =
                              {...jobFamilyDetailMap[jobFamily]};
                      if (jobFamilyDetails[actGroup]) {
                        jobFamilyDetails[actGroup] += duration;
                        jobFamilyDetailMap[jobFamily] =
                                 jobFamilyDetails;
                      } else {
                        jobFamilyDetails[actGroup] = duration;
                        jobFamilyDetailMap[jobFamily] =
                                 jobFamilyDetails;
                      }
                    } else {
                      jobFamilyActGrpMap[actGroup] = duration;
                      jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                    }
                  }
                  if (actGroup !='meal') {
                    if ( actGrpDetailMap[actGroup]) {
                      actGrpDetailMap[actGroup] +=duration;
                    } else {
                      actGrpDetailMap[actGroup] =duration;
                    }
                  }
                }
              }
            }

            const activtyGroupTotMap={};
            if (Object.keys(actGrpDetailMap).length > 0) {
              for (const activityGroup in actGrpDetailMap) {
                if (Object.prototype.hasOwnProperty
                    .call(actGrpDetailMap, activityGroup)) {
                  const duration = actGrpDetailMap[activityGroup];
                  activtyGroupTotMap[activityGroup] =
                parseFloat(duration.toFixed(2));
                }
              }
            }
            const jobFamilyTotMap ={};
            if (Object.keys(jobFamilyDetailMap).length > 0) {
              for (const jobFamily in jobFamilyDetailMap) {
                if (Object.prototype.hasOwnProperty
                    .call(jobFamilyDetailMap, jobFamily)) {
                  const activityGrpMap = jobFamilyDetailMap[jobFamily];
                  for (const activityGroup in activityGrpMap) {
                    if (Object.prototype.hasOwnProperty
                        .call(activityGrpMap, activityGroup)) {
                      const duration = activityGrpMap[activityGroup];
                      activityGrpMap[activityGroup] =
                              parseFloat(duration.toFixed(2));
                      jobFamilyTotMap[jobFamily] = activityGrpMap;
                    }
                  }
                }
              }
            }

            data.weekTotalHours.activityGroupTotals = activtyGroupTotMap;
            data.weekTotalHours.jobFamilyTotals = jobFamilyTotMap;
            const docArray = docId.split('-');
            data.workerId = docArray[1];
            data.weekNumber = docArray[0];
            // console.log("timesheet appr data:", data);
            timesheetRef
              .update(data)
              .then((docRef) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          }
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      console.error("approve save error", error);
      reject(error);
    }
  });
};

function getDurationInHours(inLocalTS, outLocalTS) {
  let hours = 0;
  try {
    if (
      inLocalTS &&
      inLocalTS !== "" &&
      inLocalTS !== "null" &&
      outLocalTS &&
      outLocalTS !== "" &&
      outLocalTS !== "null"
    ) {
      const end = moment(outLocalTS && outLocalTS.substr(0, 16));
      const start = moment(inLocalTS && inLocalTS.substr(0, 16));
      if (start.isValid() && end.isValid()) {
        const diff = moment.duration(end.diff(start));
        hours = diff.asHours();
      }
    }
  } catch (error) {
    console.error("Error in duration calculation: ", error);
  }
  return hours.toFixed(2);
}

export const createTimesheetfromPunch = async (punches, actionBy) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("createTimesheetfromPunch called");
      // console.log("punch", punch);
      const punchesSize = punches.length;
      if (punchesSize <= 0) {
        console.log("No punches found");
        const error = "No punches found";
        reject(error);
      }
      const workerIdList = punches.map(
        (eachWorkerDetail) => eachWorkerDetail.workerId
      );

      const uniqueWorkerIds = [...new Set(workerIdList)];
      const finalPunchesList = [];
      const finalMap = {};
      for (let i = 0; i < uniqueWorkerIds.length; i++) {
        const eachWorkerId = uniqueWorkerIds[i];

        const eachWorkerRecord = punches.filter(
          (e) => e.workerId === eachWorkerId
        );

        // const punchesRecords = processPunchesforTimeSheet(eachWorkerRecord);

        finalPunchesList.push(...eachWorkerRecord);
      }
      for (let i = 0; i < finalPunchesList.length; i++) {
        const punch = finalPunchesList[i];
        let weeknumber = punch.weekNumber;
        const inLocalTS = punch.inLocalTS;
        const outLocalTS = punch.outLocalTS;
        if (!weeknumber) {
          if (outLocalTS) weeknumber = getWeekNumber(outLocalTS);
          else weeknumber = getWeekNumber(inLocalTS);
        }
        const workerId = punch.workerId;
        weeknumber = weeknumber + "-" + workerId;
        const punchMap = {};
        const punchIdArray = [];
        const pendingArray = [];
        const approvedArray = [];
        const approveActivityMap = {};
        const pendingActivityMap = {};
        const punchId = punch.id;

        const punchStatus = punch.status;
        const activityGroup = punch.activityGroup;
        const duration = punch.duration;
        const jobFamily = punch.jobName;
        // console.log("punchId", punchId);
        // console.log("weeknumber", weeknumber);
        let dayName = moment(inLocalTS).format("dddd").toString();
        if (outLocalTS) dayName = moment(outLocalTS).format("dddd").toString();
        // const dayName = moment(inLocalTS).format("dddd").toString();

        punchIdArray.push(punchId);
        if (punchStatus === "approved" || punchStatus === "auto approved") {
          approvedArray.push(punchId);
          approveActivityMap[punchId] = {
            duration: parseFloat(duration),
            dayName: dayName,
            activityGroup: activityGroup,
            jobFamily:jobFamily,
          };
        } else {
          pendingArray.push(punchId);
          pendingActivityMap[punchId] = {
            duration: parseFloat(duration),
            dayName: dayName,
            activityGroup: activityGroup,
            jobFamily:jobFamily,
          };
        }

        punchMap[punchId] = punch;

        // console.log("outLocalTS", outLocalTS);
        let hours = 0.0;
        let mealHours = 0.0;
        let activityHours = 0.0;

        if (punchStatus !== "deleted" && outLocalTS !== "") {
          hours = await getDurationInHours(inLocalTS, outLocalTS);

          if (isNaN(hours)) {
            hours = 0.0;
          }
          if (activityGroup === "Meal") {
            mealHours = await getDurationInHours(inLocalTS, outLocalTS);
            if (isNaN(mealHours)) {
              mealHours = 0.0;
            }
          } else {
            activityHours = await getDurationInHours(inLocalTS, outLocalTS);
            if (isNaN(activityHours)) {
              activityHours = 0.0;
            }
          }
        }

        if (
          finalMap[weeknumber] &&
          (finalMap[weeknumber].approvedPunches ||
            finalMap[weeknumber].pendingPunches)
        ) {
          const approvedweekDataMap = finalMap[weeknumber].approvedPunches;
          const pendingweekDataMap = finalMap[weeknumber].pendingPunches;
          const dayTotalsMap = finalMap[weeknumber].dayWiseTotals;
          if (dayTotalsMap[dayName]) {
            const daywiseTotalMap = { ...dayTotalsMap[dayName] };
            daywiseTotalMap["mealHours"] += parseFloat(mealHours);
            daywiseTotalMap["activityHours"] += parseFloat(activityHours);
            daywiseTotalMap["hours"] += parseFloat(hours);
            const prevStatus = daywiseTotalMap["status"];
            if (
              (prevStatus === "approved" || prevStatus === "auto approved") &&
              (punchStatus === "approved" || punchStatus === "auto approved")
            ) {
              daywiseTotalMap["status"] = "approved";
            } else {
              daywiseTotalMap["status"] = "pending";
            }
            dayTotalsMap[dayName] = daywiseTotalMap;
            finalMap[weeknumber].dayWiseTotals = dayTotalsMap;
          } else {
            const dayDataMap = {};
            dayDataMap["mealHours"] = parseFloat(mealHours);
            dayDataMap["activityHours"] = parseFloat(activityHours);
            dayDataMap["hours"] = parseFloat(hours);
            if (punchStatus === "approved" || punchStatus === "auto approved") {
              dayDataMap["status"] = "approved";
            } else {
              dayDataMap["status"] = "pending";
            }
            dayTotalsMap[dayName] = dayDataMap;
            // daywiseTotalMap[dayName] = parseFloat(hours);
            finalMap[weeknumber].dayWiseTotals = dayTotalsMap;
          }
          const apprWeekDataMap = {
            ...approvedweekDataMap,
            ...approveActivityMap,
          };
          const pendWeekDataMap = {
            ...pendingweekDataMap,
            ...pendingActivityMap,
          };
          finalMap[weeknumber].approvedPunches = apprWeekDataMap;
          finalMap[weeknumber].pendingPunches = pendWeekDataMap;
          const weekTotals = { ...finalMap[weeknumber].duration };
          weekTotals["mealHours"] += parseFloat(mealHours);
          weekTotals["activityHours"] += parseFloat(activityHours);
          weekTotals["hours"] += parseFloat(hours);
          finalMap[weeknumber].duration = weekTotals;
        } else {
          finalMap[weeknumber] = {};
          finalMap[weeknumber].approvedPunches = approveActivityMap;
          finalMap[weeknumber].pendingPunches = pendingActivityMap;
          const weekTotalMap = {};
          weekTotalMap["mealHours"] = parseFloat(mealHours);
          weekTotalMap["activityHours"] = parseFloat(activityHours);
          weekTotalMap["hours"] = parseFloat(hours);
          finalMap[weeknumber].duration = weekTotalMap;
          finalMap[weeknumber].pendingCount = 0;
          finalMap[weeknumber].approvedCount = 0;
          finalMap[weeknumber].inProgressCount = 0;
          const daywiseTotalMap = {};
          const daysMap = {};
          daysMap["mealHours"] = parseFloat(mealHours);
          daysMap["activityHours"] = parseFloat(activityHours);
          daysMap["hours"] = parseFloat(hours);
          daysMap["status"] = "pending";

          daywiseTotalMap[dayName] = daysMap;
          finalMap[weeknumber].dayWiseTotals = daywiseTotalMap;

          if (actionBy) finalMap[weeknumber].actionBy = actionBy;
          else finalMap[weeknumber].actionBy = punch.actionBy;
        }

        if (punchStatus !== "deleted") {
          if (punchStatus === "approved" || punchStatus === "auto approved") {
            finalMap[weeknumber].approvedCount += 1;
          } else if (punchStatus != "deleted" && outLocalTS) {
            finalMap[weeknumber].pendingCount += 1;
          }
          if (!outLocalTS) {
            finalMap[weeknumber].inProgressCount += 1;
          }
        }
        if (actionBy) finalMap[weeknumber].actionBy = actionBy;
        else finalMap[weeknumber].actionBy = punch.actionBy;
        finalMap[weeknumber].weekNumber = punch.weekNumber;
        finalMap[weeknumber].workerId =punch.workerId;
      }

      await savePunchestoTimeSheet(finalMap, "create")
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      console.log("timesheet format error:", error);
      reject(error)
    }
  });
};

function savePunchestoTimeSheet(punches, CFflag, punchData) {
  console.log("4. savePunchestoTimeSheet called...");
  return new Promise(async (resolve, reject) => {
    try {
      if (punches) {
        let batch = db.batch();
        const jobFamilyDetailMap ={};
        let recordCount = 0;
        const recordsSize = Object.keys(punches).length;
        let finalMap={};
        for (const weekNumber in punches) {
          if (Object.prototype.hasOwnProperty.call(punches, weekNumber)) {
            const timesheetRef = db.collection("timesheets").doc(weekNumber);
            const activityMap = {};
            if (
              punches[weekNumber].pendingCount &&
              punches[weekNumber].pendingCount > 0
            ) {
              activityMap.timesheetStatus = "pending";
            } else if (
              punches[weekNumber].inProgressCount &&
              punches[weekNumber].inProgressCount > 0
            ) {
              activityMap.timesheetStatus = "inProgress";
            } else {
              activityMap.timesheetStatus = "approved";
            }
            const dayWiseTotalsNonZero = punches[weekNumber].dayWiseTotals;
            const dayTotalsMap = {};
            const totalDurationMap = {};
            let totalActivityHours = 0.0;
            let totalMealHours = 0.0;
            let totalHours = 0.0;
            for (const eachDay in dayWiseTotalsNonZero) {
              if (dayWiseTotalsNonZero[eachDay].hours > 0) {
                const dayTotalsData = dayWiseTotalsNonZero[eachDay];
                const activityHours = dayTotalsData.activityHours;
                const mealHours = dayTotalsData.mealHours;
                const hours = dayTotalsData.hours;
                totalActivityHours += activityHours;
                totalMealHours += mealHours;
                totalHours += hours;
                dayWiseTotalsNonZero[eachDay].activityHours = parseFloat(
                  activityHours.toFixed(2)
                );
                dayWiseTotalsNonZero[eachDay].mealHours = parseFloat(
                  mealHours.toFixed(2)
                );
                dayWiseTotalsNonZero[eachDay].hours = parseFloat(
                  hours.toFixed(2)
                );
                dayTotalsMap[eachDay] = dayWiseTotalsNonZero[eachDay];
              }
            }
            totalDurationMap.activityHours = parseFloat(
              totalActivityHours.toFixed(2)
            );
            totalDurationMap.mealHours = parseFloat(totalMealHours.toFixed(2));
            totalDurationMap.hours = parseFloat(totalHours.toFixed(2));
            activityMap.weekTotalHours = totalDurationMap;
            if (dayTotalsMap) {
              activityMap.dayTotals = dayTotalsMap;
            }
            let approvedPunchesMap = {};
            let pendingPunchesMap = {};
            if (punches[weekNumber].approvedPunches) {
              approvedPunchesMap = punches[weekNumber].approvedPunches;
              activityMap.approvedPunches = approvedPunchesMap;
            }
            if (punches[weekNumber].pendingPunches) {
              pendingPunchesMap = punches[weekNumber].pendingPunches;
              activityMap.pendingPunches = pendingPunchesMap;
            }
            const pendingPunchesArray = {...activityMap.pendingPunches};
            const approvePunchesArray = {...activityMap.approvedPunches}
            let pendingCount = 0;
            let inProgressCount = 0;
            const actGrpDetailMap={};
            if (Object.keys(activityMap.pendingPunches).length > 0) {
              const pendingPunches = activityMap.pendingPunches;
              for (const punchId in pendingPunches) {
                if (Object.prototype.hasOwnProperty
                    .call(pendingPunches, punchId)) {
                  let actGroup = pendingPunches[punchId]
                      .activityGroup;
                      actGroup = properCamelCase(actGroup);
                  const duration = pendingPunches[punchId].duration;
                  let jobFamily = pendingPunches[punchId].jobFamily;
                  const jobFamilyActGrpMap={};
                  if (jobFamily) {
                    jobFamily = properCamelCaseNew(jobFamily);
                    if ( jobFamilyDetailMap[jobFamily]) {
                      const jobFamilyDetails =
                              {...jobFamilyDetailMap[jobFamily]};
                      if (jobFamilyDetails[actGroup]) {
                        jobFamilyDetails[actGroup] += duration;
                        jobFamilyDetailMap[jobFamily] =
                                 jobFamilyDetails;
                      } else {
                        jobFamilyDetails[actGroup] = duration;
                        jobFamilyDetailMap[jobFamily] =
                                 jobFamilyDetails;
                      }
                    } else {
                      jobFamilyActGrpMap[actGroup] = duration;
                      jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                    }
                  }

                  if (actGroup !='meal') {
                    if ( actGrpDetailMap[actGroup]) {
                      actGrpDetailMap[actGroup] +=duration;
                    } else {
                      actGrpDetailMap[actGroup] =duration;
                    }
                  }
                  if (duration === 0) {
                    inProgressCount += 1;
                  } else {
                    pendingCount += 1;
                  }
                }
              }
            }

            if (Object.keys(activityMap.approvedPunches).length > 0) {
              const approvedPunches = activityMap.approvedPunches;
              for (const punchId in approvedPunches) {
                if (Object.prototype.hasOwnProperty
                    .call(approvedPunches, punchId)) {
                  let actGroup = approvedPunches[punchId]
                      .activityGroup;
                      actGroup = properCamelCase(actGroup);
                  const duration = approvedPunches[punchId].duration;
                  let jobFamily = approvedPunches[punchId].jobFamily;
                  const jobFamilyActGrpMap={};
                  if (jobFamily) {
                    jobFamily = properCamelCaseNew(jobFamily);
                    if ( jobFamilyDetailMap[jobFamily]) {
                      const jobFamilyDetails =
                              {...jobFamilyDetailMap[jobFamily]};
                      if (jobFamilyDetails[actGroup]) {
                        jobFamilyDetails[actGroup] += duration;
                        jobFamilyDetailMap[jobFamily] =
                                 jobFamilyDetails;
                      } else {
                        jobFamilyDetails[actGroup] = duration;
                        jobFamilyDetailMap[jobFamily] =
                                 jobFamilyDetails;
                      }
                    } else {
                      jobFamilyActGrpMap[actGroup] = duration;
                      jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                    }
                  }

                  if (actGroup !='meal') {
                    if ( actGrpDetailMap[actGroup]) {
                      actGrpDetailMap[actGroup] +=duration;
                    } else {
                      actGrpDetailMap[actGroup] =duration;
                    }
                  }
                }
              }
            }

            
            const activtyGroupTotMap={};
            const timesheetDataRef = await timesheetRef.get();
            if (timesheetDataRef.exists) {
              const timesheetData = timesheetDataRef.data();
              if (
                punchData &&
                punchData.status === "deleted" &&
                timesheetData.timesheetStatus === "approved"
              ) {
                activityMap.timesheetStatus = "pending";
              }

              const daysArray = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
              ];

              if (
                CFflag &&
                timesheetData &&
                timesheetData.timesheetStatus != "deleted"
              ) {
                const timeSheetDayTotals = timesheetData.dayTotals;
                const tSPendingPunches = timesheetData.pendingPunches;
                const tSApprovedPunches = timesheetData.approvedPunches;
                for (let i = 0; i < daysArray.length; i++) {
                  const eachDayName = daysArray[i];
                  if (
                    timeSheetDayTotals[eachDayName] &&
                    !dayTotalsMap[eachDayName] &&
                    activityMap.weekTotalHours
                  ) {
                    const activityHours =
                      timeSheetDayTotals[eachDayName].activityHours;
                    const mealHours = timeSheetDayTotals[eachDayName].mealHours;
                    const hours = timeSheetDayTotals[eachDayName].hours;
                    activityMap.weekTotalHours.activityHours += activityHours;
                    activityMap.weekTotalHours.mealHours += mealHours;
                    activityMap.weekTotalHours.hours += hours;
                  }
                  if (
                    timeSheetDayTotals[eachDayName] &&
                    dayTotalsMap[eachDayName]
                  ) {
                    const activityHours =
                      timeSheetDayTotals[eachDayName].activityHours;
                    const mealHours = timeSheetDayTotals[eachDayName].mealHours;
                    const hours = timeSheetDayTotals[eachDayName].hours;
                    dayTotalsMap[eachDayName].activityHours += activityHours;
                    dayTotalsMap[eachDayName].mealHours += mealHours;
                    dayTotalsMap[eachDayName].hours += hours;
                    activityMap.weekTotalHours.activityHours += activityHours;
                    activityMap.weekTotalHours.mealHours += mealHours;
                    activityMap.weekTotalHours.hours += hours;
                  }
                }
                if (activityMap.weekTotalHours.activityHours) {
                  activityMap.weekTotalHours.activityHours = parseFloat(
                    activityMap.weekTotalHours.activityHours.toFixed(2)
                  );
                }
                if (activityMap.weekTotalHours.mealHours) {
                  activityMap.weekTotalHours.mealHours = parseFloat(
                    activityMap.weekTotalHours.mealHours.toFixed(2)
                  );
                }
                if (activityMap.weekTotalHours.hours) {
                  activityMap.weekTotalHours.hours = parseFloat(
                    activityMap.weekTotalHours.hours.toFixed(2)
                  );
                }
                if (
                  Object.keys(pendingPunchesMap).length === 0 &&
                  tSPendingPunches
                ) {
                  activityMap.pendingPunches = tSPendingPunches;
                }
                if (
                  Object.keys(approvedPunchesMap).length === 0 &&
                  tSApprovedPunches
                ) {
                  activityMap.approvedPunches = tSApprovedPunches;
                }


                if (Object.keys(tSPendingPunches).length > 0) {
                  const pendingPunches = tSPendingPunches;
                  for (const punchId in pendingPunches) {
                    if (Object.prototype.hasOwnProperty
                        .call(pendingPunches, punchId) &&
                        !pendingPunchesArray[punchId]) {
                      let actGroup = pendingPunches[punchId]
                          .activityGroup;
                          actGroup = properCamelCase(actGroup);
                      const duration = pendingPunches[punchId].duration;
                      let jobFamily = pendingPunches[punchId].jobFamily;
                      const jobFamilyActGrpMap={};
                      if (jobFamily) {
                        jobFamily = properCamelCaseNew(jobFamily);
                        if ( jobFamilyDetailMap[jobFamily]) {
                          const jobFamilyDetails =
                                  {...jobFamilyDetailMap[jobFamily]};
                          if (jobFamilyDetails[actGroup]) {
                            jobFamilyDetails[actGroup] += duration;
                            jobFamilyDetailMap[jobFamily] =
                                    jobFamilyDetails;
                          } else {
                            jobFamilyDetails[actGroup] = duration;
                            jobFamilyDetailMap[jobFamily] =
                                    jobFamilyDetails;
                          }
                        } else {
                          jobFamilyActGrpMap[actGroup] = duration;
                          jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                        }
                      }

                      if (actGroup !='meal') {
                        if ( actGrpDetailMap[actGroup]) {
                          actGrpDetailMap[actGroup] +=duration;
                        } else {
                          actGrpDetailMap[actGroup] =duration;
                        }
                      }
                      if (duration === 0) {
                        inProgressCount += 1;
                      } else {
                        pendingCount += 1;
                      }
                    }
                  }
                }
    
                if (Object.keys(tSApprovedPunches).length > 0) {
                  const approvedPunches = tSApprovedPunches;
                  for (const punchId in approvedPunches) {
                    if (Object.prototype.hasOwnProperty
                        .call(approvedPunches, punchId) &&
                        !approvePunchesArray[punchId]) {
                      let actGroup = approvedPunches[punchId]
                          .activityGroup;
                          actGroup = properCamelCase(actGroup);
                      const duration = approvedPunches[punchId].duration;
                      let jobFamily = approvedPunches[punchId].jobFamily;
                      const jobFamilyActGrpMap={};
                      if (jobFamily) {
                        jobFamily = properCamelCaseNew(jobFamily);
                        if ( jobFamilyDetailMap[jobFamily]) {
                          const jobFamilyDetails =
                                  {...jobFamilyDetailMap[jobFamily]};
                          if (jobFamilyDetails[actGroup]) {
                            jobFamilyDetails[actGroup] += duration;
                            jobFamilyDetailMap[jobFamily] =
                                    jobFamilyDetails;
                          } else {
                            jobFamilyDetails[actGroup] = duration;
                            jobFamilyDetailMap[jobFamily] =
                                    jobFamilyDetails;
                          }
                        } else {
                          jobFamilyActGrpMap[actGroup] = duration;
                          jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                        }
                      }

                      if (actGroup !='meal') {
                        if ( actGrpDetailMap[actGroup]) {
                          actGrpDetailMap[actGroup] +=duration;
                        } else {
                          actGrpDetailMap[actGroup] =duration;
                        }
                      }
                    }
                  }
                }

              }
            }
            
            

            if (Object.keys(actGrpDetailMap).length > 0) {
              for (const activityGroup in actGrpDetailMap) {
                if (Object.prototype.hasOwnProperty
                    .call(actGrpDetailMap, activityGroup)) {
                  const duration = actGrpDetailMap[activityGroup];
                  activtyGroupTotMap[activityGroup] =
                parseFloat(duration.toFixed(2));
                }
              }
            }
            const jobFamilyTotMap ={};
            if (Object.keys(jobFamilyDetailMap).length > 0) {
              for (const jobFamily in jobFamilyDetailMap) {
                if (Object.prototype.hasOwnProperty
                    .call(jobFamilyDetailMap, jobFamily)) {
                  const activityGrpMap = jobFamilyDetailMap[jobFamily];
                  for (const activityGroup in activityGrpMap) {
                    if (Object.prototype.hasOwnProperty
                        .call(activityGrpMap, activityGroup)) {
                      const duration = activityGrpMap[activityGroup];
                      activityGrpMap[activityGroup] =
                              parseFloat(duration.toFixed(2));
                      jobFamilyTotMap[jobFamily] = activityGrpMap;
                    }
                  }
                }
              }
            }

            if (pendingCount > 0) {
              activityMap.timesheetStatus = "pending";
            } else if (inProgressCount > 0) {
              activityMap.timesheetStatus = "inprogress";
            } else{
              activityMap.timesheetStatus = "approved";
            }

            activityMap.weekTotalHours.activityGroupTotals =
                activtyGroupTotMap;
            activityMap.weekTotalHours.jobFamilyTotals = 
            jobFamilyTotMap;
            activityMap.weekNumber = punches[weekNumber].weekNumber;
            activityMap.workerId = punches[weekNumber].workerId;
            activityMap.actionTS = new Date().toISOString();
            activityMap.actionBy = punches[weekNumber].actionBy;
            finalMap = {...activityMap};
            batch.set(timesheetRef, activityMap, { merge: true });
            recordCount++;
          }
        }
        await batch.commit();

        console.log("6. savePunchestoTimeSheet completed");
        resolve(finalMap);
      } else {
        const error = "Nothing to process";
        reject(error);
      }
    } catch (error) {
      console.error("in services > savePunchestoTimeSheet, Err===", error);
      reject(error);
    }
  });
}

export const createTimesheetfromContractorPunch = async (punches, actionBy) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("createTimesheetfromPunch called");
      // console.log("punch", punch);
      const punchesSize = punches.length;
      if (punchesSize <= 0) {
        console.log("No punches found");
        const error = "No punches found";
        reject(error);
      }
      const workerIdList = punches.map(
        (eachWorkerDetail) => eachWorkerDetail.workerId
      );

      const uniqueWorkerIds = [...new Set(workerIdList)];
      const finalPunchesList = [];
      const finalMap = {};
      for (let i = 0; i < uniqueWorkerIds.length; i++) {
        const eachWorkerId = uniqueWorkerIds[i];

        const eachWorkerRecord = punches.filter(
          (e) => e.workerId === eachWorkerId
        );

        // const punchesRecords = processPunchesforTimeSheet(eachWorkerRecord);

        finalPunchesList.push(...eachWorkerRecord);
      }
      for (let i = 0; i < finalPunchesList.length; i++) {
        const punch = finalPunchesList[i];
        let weeknumber = punch.weekNumber;
        const inLocalTS = punch.inLocalTS;
        const outLocalTS = punch.outLocalTS;
        if (!weeknumber) {
          if (outLocalTS) weeknumber = getWeekNumber(outLocalTS);
          else weeknumber = getWeekNumber(inLocalTS);
        }
        const workerId = punch.workerId;
        weeknumber = weeknumber + "-" + workerId;
        const punchMap = {};
        const punchIdArray = [];
        const pendingArray = [];
        const approvedArray = [];
        const approveActivityMap = {};
        const pendingActivityMap = {};
        const punchId = punch.id;

        const punchStatus = punch.status;
        const activityGroup = punch.activityGroup;
        const duration = punch.duration;
        const jobFamily = punch.jobName;
        // console.log("punchId", punchId);
        // console.log("weeknumber", weeknumber);
        let dayName = moment(inLocalTS).format("dddd").toString();
        if (outLocalTS) dayName = moment(outLocalTS).format("dddd").toString();
        // const dayName = moment(inLocalTS).format("dddd").toString();

        punchIdArray.push(punchId);
        if (punchStatus === "approved" || punchStatus === "auto approved") {
          approvedArray.push(punchId);
          approveActivityMap[punchId] = {
            duration: parseFloat(duration),
            dayName: dayName,
            activityGroup: activityGroup,
            jobFamily:jobFamily,
          };
        } else if(punchStatus !== DELETED_STATUS) {
          pendingArray.push(punchId);
          pendingActivityMap[punchId] = {
            duration: parseFloat(duration),
            dayName: dayName,
            activityGroup: activityGroup,
            jobFamily:jobFamily,
          };
        }

        punchMap[punchId] = punch;

        // console.log("outLocalTS", outLocalTS);
        let hours = 0.0;
        let mealHours = 0.0;
        let activityHours = 0.0;

        if (punchStatus !== "deleted" && outLocalTS !== "") {
          hours = await getDurationInHours(inLocalTS, outLocalTS);

          if (isNaN(hours)) {
            hours = 0.0;
          }
          if (activityGroup === "Meal") {
            mealHours = await getDurationInHours(inLocalTS, outLocalTS);
            if (isNaN(mealHours)) {
              mealHours = 0.0;
            }
          } else {
            activityHours = await getDurationInHours(inLocalTS, outLocalTS);
            if (isNaN(activityHours)) {
              activityHours = 0.0;
            }
          }
        }

        if (
          finalMap[weeknumber] &&
          (finalMap[weeknumber].approvedPunches ||
            finalMap[weeknumber].pendingPunches)
        ) {
          const approvedweekDataMap = finalMap[weeknumber].approvedPunches;
          const pendingweekDataMap = finalMap[weeknumber].pendingPunches;
          const dayTotalsMap = finalMap[weeknumber].dayWiseTotals;
          if (dayTotalsMap[dayName]) {
            const daywiseTotalMap = { ...dayTotalsMap[dayName] };
            daywiseTotalMap["mealHours"] += parseFloat(mealHours);
            daywiseTotalMap["activityHours"] += parseFloat(activityHours);
            daywiseTotalMap["hours"] += parseFloat(hours);
            const prevStatus = daywiseTotalMap["status"];
            if (
              (prevStatus === "approved" || prevStatus === "auto approved") &&
              (punchStatus === "approved" || punchStatus === "auto approved")
            ) {
              daywiseTotalMap["status"] = "approved";
            } else {
              daywiseTotalMap["status"] = "pending";
            }
            dayTotalsMap[dayName] = daywiseTotalMap;
            finalMap[weeknumber].dayWiseTotals = dayTotalsMap;
          } else {
            const dayDataMap = {};
            dayDataMap["mealHours"] = parseFloat(mealHours);
            dayDataMap["activityHours"] = parseFloat(activityHours);
            dayDataMap["hours"] = parseFloat(hours);
            if (punchStatus === "approved" || punchStatus === "auto approved") {
              dayDataMap["status"] = "approved";
            } else {
              dayDataMap["status"] = "pending";
            }
            dayTotalsMap[dayName] = dayDataMap;
            // daywiseTotalMap[dayName] = parseFloat(hours);
            finalMap[weeknumber].dayWiseTotals = dayTotalsMap;
          }
          const apprWeekDataMap = {
            ...approvedweekDataMap,
            ...approveActivityMap,
          };
          const pendWeekDataMap = {
            ...pendingweekDataMap,
            ...pendingActivityMap,
          };
          finalMap[weeknumber].approvedPunches = apprWeekDataMap;
          finalMap[weeknumber].pendingPunches = pendWeekDataMap;
          const weekTotals = { ...finalMap[weeknumber].duration };
          weekTotals["mealHours"] += parseFloat(mealHours);
          weekTotals["activityHours"] += parseFloat(activityHours);
          weekTotals["hours"] += parseFloat(hours);
          finalMap[weeknumber].duration = weekTotals;
        } else {
          finalMap[weeknumber] = {};
          finalMap[weeknumber].approvedPunches = approveActivityMap;
          finalMap[weeknumber].pendingPunches = pendingActivityMap;
          const weekTotalMap = {};
          weekTotalMap["mealHours"] = parseFloat(mealHours);
          weekTotalMap["activityHours"] = parseFloat(activityHours);
          weekTotalMap["hours"] = parseFloat(hours);
          finalMap[weeknumber].duration = weekTotalMap;
          finalMap[weeknumber].pendingCount = 0;
          finalMap[weeknumber].approvedCount = 0;
          finalMap[weeknumber].inProgressCount = 0;
          const daywiseTotalMap = {};
          const daysMap = {};
          daysMap["mealHours"] = parseFloat(mealHours);
          daysMap["activityHours"] = parseFloat(activityHours);
          daysMap["hours"] = parseFloat(hours);
          daysMap["status"] = "pending";

          daywiseTotalMap[dayName] = daysMap;
          finalMap[weeknumber].dayWiseTotals = daywiseTotalMap;

          if (actionBy) finalMap[weeknumber].actionBy = actionBy;
          else finalMap[weeknumber].actionBy = punch.actionBy;
        }

        if (punchStatus !== "deleted") {
          if (punchStatus === "approved" || punchStatus === "auto approved") {
            finalMap[weeknumber].approvedCount += 1;
          } else if (punchStatus != "deleted" && outLocalTS) {
            finalMap[weeknumber].pendingCount += 1;
          }
          if (!outLocalTS) {
            finalMap[weeknumber].inProgressCount += 1;
          }
        }
        if (actionBy) finalMap[weeknumber].actionBy = actionBy;
        else finalMap[weeknumber].actionBy = punch.actionBy;
        finalMap[weeknumber].weekNumber = punch.weekNumber;
        finalMap[weeknumber].workerId =punch.workerId;
      }

      console.log("finalMap", finalMap);
      await saveContractorPunchestoTimeSheet(finalMap, 'triggerCF')
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      console.log("timesheet format error:", error);
      reject(error)
    }
  });
};

/**
 * Saves the punches to timesheet collection.
 * @param {Object} punches punches to save.
 * @param {String} CFflag The first number.
 * @param {Object} punchData punch record from 2nd CF.
 * @return {Promise} Promise
 */
function saveContractorPunchestoTimeSheet(punches, CFflag, punchData) {
  console.log('4. savePunchestoTimeSheet called...');
  return new Promise(async (resolve, reject) => {
    try {
      if (punches) {
        let batch = db.batch();
        let recordCount = 0;
        const recordsSize = Object.keys(punches).length;
        for (const weekNumber in punches) {
          if (Object.prototype.hasOwnProperty.call(punches, weekNumber)) {
            const timesheetRef = db.collection('timesheets')
                .doc(weekNumber);

            const activityMap={};
            //activityMap.actionBy= config.system;
            if (CFflag && CFflag ==='triggerCF') {
              activityMap.actionBy= punches[weekNumber].actionBy;
            }
            if (
              punches[weekNumber].pendingCount &&
                punches[weekNumber].pendingCount > 0
            ) {
              activityMap.timesheetStatus = 'pending';
            } else if (punches[weekNumber].inProgressCount &&
              punches[weekNumber].inProgressCount > 0 ) {
              activityMap.timesheetStatus = 'inProgress';
            } else {
              activityMap.timesheetStatus = 'approved';
            }
            // if (punches[weekNumber].inProgressCount &&
            //       punches[weekNumber].inProgressCount >0) {
            //   activityMap.timesheetStatus = 'inProgress';
            // }
            const dayWiseTotalsNonZero = punches[weekNumber].dayWiseTotals;

            const dayTotalsMap ={};
            const totalDurationMap={};
            let totalActivityHours = 0.0;
            let totalMealHours =0.0;
            let totalHours =0.0;
            for (const eachDay in dayWiseTotalsNonZero) {
              if (dayWiseTotalsNonZero[eachDay].hours > 0) {
                const dayTotalsData = dayWiseTotalsNonZero[eachDay];
                const activityHours = dayTotalsData.activityHours;
                const mealHours = dayTotalsData.mealHours;
                const hours = dayTotalsData.hours;
                totalActivityHours +=activityHours;
                totalMealHours +=mealHours;
                totalHours +=hours;
                dayWiseTotalsNonZero[eachDay].activityHours =
                   parseFloat(activityHours.toFixed(2));
                dayWiseTotalsNonZero[eachDay].mealHours =
                  parseFloat(mealHours.toFixed(2));
                dayWiseTotalsNonZero[eachDay].hours =
                parseFloat(hours.toFixed(2));
                dayTotalsMap[eachDay] = dayWiseTotalsNonZero[eachDay];
              }
            }
            totalDurationMap.activityHours =
              parseFloat(totalActivityHours.toFixed(2));
            totalDurationMap.mealHours = parseFloat(totalMealHours.toFixed(2));
            totalDurationMap.hours = parseFloat(totalHours.toFixed(2));
            activityMap.weekTotalHours = totalDurationMap;
            if (dayTotalsMap) {
              activityMap.dayTotals = dayTotalsMap;
            }

            let approvedPunchesMap={};
            let pendingPunchesMap={};
            if (punches[weekNumber].approvedPunches) {
              approvedPunchesMap = punches[weekNumber].approvedPunches;
              activityMap.approvedPunches = approvedPunchesMap;
            }
            if (punches[weekNumber].pendingPunches) {
              pendingPunchesMap = punches[weekNumber].pendingPunches;
              activityMap.pendingPunches = pendingPunchesMap;
            }
            const pendingPunchesArray = {...activityMap.pendingPunches};
            const approvedPunchesArray = {...activityMap.approvedPunches};
            const actGrpDetailMap={};
            const jobFamilyDetailMap={};
            let pendingCount=0;
            let inProgressCount=0;

            if (Object.keys(activityMap.pendingPunches).length > 0) {
              const pendingPunches = activityMap.pendingPunches;
              for (const punchId in pendingPunches) {
                if (Object.prototype.hasOwnProperty
                    .call(pendingPunches, punchId)) {
                  let actGroup = pendingPunches[punchId]
                      .activityGroup;
                  let jobFamily = pendingPunches[punchId]
                      .jobFamily;
                  jobFamily = properCamelCaseNew(jobFamily);
                  actGroup = properCamelCase(actGroup);
                  const duration = pendingPunches[punchId].duration;
                  const jobFamilyActGrpMap={};
                  if ( jobFamilyDetailMap[jobFamily]) {
                    const jobFamilyDetails ={...jobFamilyDetailMap[jobFamily]};
                    if (jobFamilyDetails[actGroup]) {
                      jobFamilyDetails[actGroup] += duration;
                      jobFamilyDetailMap[jobFamily] = jobFamilyDetails;
                    } else {
                      jobFamilyDetails[actGroup] = duration;
                      jobFamilyDetailMap[jobFamily] = jobFamilyDetails;
                    }
                  } else {
                    jobFamilyActGrpMap[actGroup] = duration;
                    jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                  }
                  if (actGroup !='meal') {
                    if ( actGrpDetailMap[actGroup]) {
                      actGrpDetailMap[actGroup] +=duration;
                    } else {
                      actGrpDetailMap[actGroup] =duration;
                    }
                  }
                  if (duration === 0) {
                    inProgressCount+=1;
                  } else {
                    pendingCount+=1;
                  }
                }
              }
            }

            if (Object.keys(activityMap.approvedPunches).length > 0) {
              const approvedPunches = activityMap.approvedPunches;
              for (const punchId in approvedPunches) {
                if (Object.prototype.hasOwnProperty
                    .call(approvedPunches, punchId)) {
                  let actGroup = approvedPunches[punchId]
                      .activityGroup;
                  actGroup = properCamelCase(actGroup);
                  let jobFamily = approvedPunches[punchId]
                      .jobFamily;
                  const duration = approvedPunches[punchId].duration;
                  jobFamily = properCamelCaseNew(jobFamily);
                  const jobFamilyActGrpMap={};
                  if ( jobFamilyDetailMap[jobFamily]) {
                    const jobFamilyDetails ={...jobFamilyDetailMap[jobFamily]};
                    if (jobFamilyDetails[actGroup]) {
                      jobFamilyDetails[actGroup] += duration;
                      jobFamilyDetailMap[jobFamily] = jobFamilyDetails;
                    } else {
                      jobFamilyDetails[actGroup] = duration;
                      jobFamilyDetailMap[jobFamily] = jobFamilyDetails;
                    }
                  } else {
                    jobFamilyActGrpMap[actGroup] = duration;
                    jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                  }

                  if (actGroup !='meal') {
                    if ( actGrpDetailMap[actGroup]) {
                      actGrpDetailMap[actGroup] +=duration;
                    } else {
                      actGrpDetailMap[actGroup] =duration;
                    }
                  }
                }
              }
            }


            const timesheetDataRef = await timesheetRef.get();
            if (timesheetDataRef.exists) {
              const timesheetData = timesheetDataRef.data();
              if (punchData && punchData.status ==='deleted' &&
                  timesheetData.timesheetStatus ==='approved') {
                activityMap.timesheetStatus = 'pending';
              }

              const daysArray =['Sunday', 'Monday', 'Tuesday', 'Wednesday',
                'Thursday', 'Friday', 'Saturday'];

              if (!CFflag && timesheetData) {
                const timeSheetDayTotals = timesheetData.dayTotals;
                const tSApprovedPunches = timesheetData.approvedPunches;
                const tSPendingPunches = timesheetData.pendingPunches;

                if (Object.keys(pendingPunchesMap).length === 0 &&
                    tSPendingPunches) {
                  activityMap.pendingPunches = tSPendingPunches;
                }
                if (Object.keys(approvedPunchesMap).length === 0 &&
                    tSApprovedPunches) {
                  activityMap.approvedPunches = tSApprovedPunches;
                }

                for (let i=0; i<daysArray.length; i++) {
                  const eachDayName = daysArray[i];
                  if (timeSheetDayTotals[eachDayName] &&
                      !dayTotalsMap[eachDayName] &&
                      activityMap.weekTotalHours) {
                    const activityHours =
                      timeSheetDayTotals[eachDayName].activityHours;
                    const mealHours = timeSheetDayTotals[eachDayName].mealHours;
                    const hours = timeSheetDayTotals[eachDayName].hours;
                    activityMap.weekTotalHours.activityHours +=activityHours;
                    activityMap.weekTotalHours.mealHours +=mealHours;
                    activityMap.weekTotalHours.hours +=hours;
                  }
                }
                if (activityMap.weekTotalHours.activityHours) {
                  activityMap.weekTotalHours.activityHours =
                parseFloat(activityMap.weekTotalHours.activityHours.toFixed(2));
                }
                if (activityMap.weekTotalHours.mealHours) {
                  activityMap.weekTotalHours.mealHours =
                  parseFloat(activityMap.weekTotalHours.mealHours.toFixed(2));
                }
                if (activityMap.weekTotalHours.hours) {
                  activityMap.weekTotalHours.hours =
                  parseFloat(activityMap.weekTotalHours.hours.toFixed(2));
                }


                if (Object.keys(tSPendingPunches).length > 0) {
                  const pendingPunches = tSPendingPunches;
                  for (const punchId in pendingPunches) {
                    if (Object.prototype.hasOwnProperty
                        .call(pendingPunches, punchId) &&
                        !pendingPunchesArray[punchId]) {
                      let actGroup = pendingPunches[punchId]
                          .activityGroup;
                      actGroup = properCamelCase(actGroup);
                      const duration = pendingPunches[punchId].duration;
                      let jobFamily = pendingPunches[punchId].jobFamily;
                      const jobFamilyActGrpMap={};
                      if (jobFamily) {
                        jobFamily = properCamelCaseNew(jobFamily);
                        if ( jobFamilyDetailMap[jobFamily]) {
                          const jobFamilyDetails =
                          {...jobFamilyDetailMap[jobFamily]};
                          if (jobFamilyDetails[actGroup]) {
                            jobFamilyDetails[actGroup] += duration;
                            jobFamilyDetailMap[jobFamily] = jobFamilyDetails;
                          } else {
                            jobFamilyDetails[actGroup] = duration;
                            jobFamilyDetailMap[jobFamily] = jobFamilyDetails;
                          }
                        } else {
                          jobFamilyActGrpMap[actGroup] = duration;
                          jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                        }
                      }
                      if (actGroup !='meal') {
                        if ( actGrpDetailMap[actGroup]) {
                          actGrpDetailMap[actGroup] +=duration;
                        } else {
                          actGrpDetailMap[actGroup] =duration;
                        }
                      }
                      if (duration === 0) {
                        inProgressCount+=1;
                      } else {
                        pendingCount+=1;
                      }
                    }
                  }
                }

                if (Object.keys(tSApprovedPunches).length > 0) {
                  const approvedPunches = tSApprovedPunches;
                  for (const punchId in approvedPunches) {
                    if (Object.prototype.hasOwnProperty
                        .call(approvedPunches, punchId) &&
                        !approvedPunchesArray[punchId]) {
                      let actGroup = approvedPunches[punchId]
                          .activityGroup;
                      actGroup = properCamelCase(actGroup);
                      let jobFamily = approvedPunches[punchId].jobFamily;
                      const duration = approvedPunches[punchId].duration;
                      const jobFamilyActGrpMap={};
                      if (jobFamily) {
                        jobFamily = properCamelCaseNew(jobFamily);
                        if ( jobFamilyDetailMap[jobFamily]) {
                          const jobFamilyDetails =
                          {...jobFamilyDetailMap[jobFamily]};
                          if (jobFamilyDetails[actGroup]) {
                            jobFamilyDetails[actGroup] += duration;
                            jobFamilyDetailMap[jobFamily] = jobFamilyDetails;
                          } else {
                            jobFamilyDetails[actGroup] = duration;
                            jobFamilyDetailMap[jobFamily] = jobFamilyDetails;
                          }
                        } else {
                          jobFamilyActGrpMap[actGroup] = duration;
                          jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                        }
                      }
                      if (actGroup !='meal') {
                        if ( actGrpDetailMap[actGroup]) {
                          actGrpDetailMap[actGroup] +=duration;
                        } else {
                          actGrpDetailMap[actGroup] =duration;
                        }
                      }
                    }
                  }
                }
              }
            }

            const activtyGroupTotMap={};
            const jobFamilyTotMap={};
            if (Object.keys(actGrpDetailMap).length > 0) {
              for (const activityGroup in actGrpDetailMap) {
                if (Object.prototype.hasOwnProperty
                    .call(actGrpDetailMap, activityGroup)) {
                  const duration = actGrpDetailMap[activityGroup];
                  activtyGroupTotMap[activityGroup] =
                parseFloat(duration.toFixed(2));
                }
              }
            }
            if (Object.keys(jobFamilyDetailMap).length > 0) {
              for (const jobFamily in jobFamilyDetailMap) {
                if (Object.prototype.hasOwnProperty
                    .call(jobFamilyDetailMap, jobFamily)) {
                  const activityGrpMap = jobFamilyDetailMap[jobFamily];
                  for (const activityGroup in activityGrpMap) {
                    if (Object.prototype.hasOwnProperty
                        .call(activityGrpMap, activityGroup)) {
                      const duration = activityGrpMap[activityGroup];
                      activityGrpMap[activityGroup] =
                      parseFloat(duration.toFixed(2));
                      jobFamilyTotMap[jobFamily] = activityGrpMap;
                    }
                  }
                }
              }
            }
            if (pendingCount>0) {
              activityMap.timesheetStatus = 'pending';
            } else if (inProgressCount>0) {
              activityMap.timesheetStatus = 'inprogress';
            }else if(pendingCount <=0 && Object.keys(activityMap.approvedPunches).length<=0) {
              activityMap.timesheetStatus = "deleted"
            } else {
              activityMap.timesheetStatus = 'approved';
            }

            activityMap.weekTotalHours.activityGroupTotals =
            activtyGroupTotMap;
            activityMap.weekTotalHours.jobFamilyTotals =jobFamilyTotMap;
            activityMap.actionTS= new Date().toISOString();
            activityMap.weekNumber = punches[weekNumber].weekNumber;
            activityMap.workerId = punches[weekNumber].workerId;
            console.log("finalmap1", activityMap);
            if (CFflag && CFflag ==='triggerCF') {
              batch.set(timesheetRef, activityMap, {merge: false});
            } else {
              batch.set(timesheetRef, activityMap, {merge: true});
            }
            recordCount++;
            if (recordCount % batchSize === 0) {
              console.log(`5. record batch size:`+
              `${(recordsSize % batchSize) + 1}`);
              await batch.commit();
              batch = db.batch();
            }
          }
        }
        if (!(recordCount % batchSize) == 0) {
          console.log(`5. Writing records `+
              `${(recordsSize % batchSize) + 1}`);
          await batch.commit();
        }
        console.log('6. savePunchestoTimeSheet completed');
        resolve(true);
      } else {
        const error = 'Nothing to process';
        reject(error);
      }
    } catch (error) {
      console.error('in services > savePunchestoTimeSheet, Err===', error);
      reject(error);
    }
  });
}

export const updateTimesheetfromPunch = async (
  punch,
  actionBy,
  deleteFlag,
  docId,
  isInProgressPunch
) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("updateTimesheetfromPunch called");
      // console.log("punch", punch);
      let weekNumber;
      if (docId) weekNumber = docId;
      else {
        weekNumber = punch.weekNumber;
        const workerId = punch.workerId;
        weekNumber = weekNumber + "-" + workerId;
      }
      const punchMap = {};
      const punchIdArray = [];
      const punchId = punch.id;
      punchIdArray.push(punchId);

      punchMap[punchId] = punch;
      const inLocalTS = punch.inLocalTS;
      let outLocalTS = punch.outLocalTS;
      const punchStatus = punch.status;
      const activityGroup = punch.activityGroup;
      const jobFamily = punch.jobName;
      console.log("isInProgressPunch:", isInProgressPunch);
      let dayName;
      if (outLocalTS) dayName = moment(outLocalTS).format("dddd").toString();
      if (deleteFlag && isInProgressPunch) {
        console.log("delete inprogress punch");
        dayName = moment(inLocalTS).format("dddd").toString();
        outLocalTS = inLocalTS;
      }
      console.log("dayName:", dayName);
      console.log("punchId:", punchId);
      let hours = 0.0;
      let mealHours = 0.0;
      let activityHours = 0.0;

      if (punchStatus !== "deleted" && outLocalTS !== "") {
        hours =  getDurationInHours(inLocalTS, outLocalTS);

        if (isNaN(hours)) {
          hours = 0.0;
        }
        if (activityGroup === "Meal") {
          mealHours =  getDurationInHours(inLocalTS, outLocalTS);
          if (isNaN(mealHours)) {
            mealHours = 0.0;
          }
        } else {
          activityHours =  getDurationInHours(inLocalTS, outLocalTS);
          if (isNaN(activityHours)) {
            activityHours = 0.0;
          }
        }
      }
      // hours = parseFloat(hours) + parseFloat(activityHours);

      let daysArray = [];
      daysArray.push(dayName);

      const timesheetRef = db.collection("timesheets").doc(weekNumber);

      timesheetRef
        .get()
        .then(async (data) => {
          if (data.exists) {
            const jobFamilyDetailMap ={};
            const timesheetData = data.data();
            let dayTotals = timesheetData.dayTotals;
            let pendingPunches = {};
            let approvedPunches = {};
            if (timesheetData.pendingPunches)
              pendingPunches = timesheetData.pendingPunches;
            if (timesheetData.approvedPunches)
              approvedPunches = timesheetData.approvedPunches;
            let days = Object.keys(dayTotals);
            for (let i = 0; i < days.length; i++) {
              let eachDay = days[i];
              daysArray.push(eachDay);
            }
            timesheetData.timesheetStatus = "pending";
            let weekTotalHours = timesheetData.weekTotalHours;
            if (actionBy) timesheetData.actionBy = actionBy;
            timesheetData.actionTS = new Date().toISOString();
            if (dayTotals[dayName]) {
              dayTotals[dayName].status = "pending";
              if (deleteFlag) {
                dayTotals[dayName].activityHours -= parseFloat(activityHours);
                dayTotals[dayName].mealHours -= parseFloat(mealHours);
                dayTotals[dayName].hours -= parseFloat(hours);
                dayTotals[dayName].status = "pending";
                if (pendingPunches && pendingPunches[punchId])
                  delete pendingPunches[punchId];

                if (approvedPunches && approvedPunches[punchId])
                  delete approvedPunches[punchId];
              } else {
                console.log("else called");
                if (pendingPunches && pendingPunches[punchId]) {
                  // console.log("dayTotalsTemp", pendingPunches[punchId]);
                  const prevDuration = pendingPunches[punchId].duration;
                  const prevDayName = pendingPunches[punchId].dayName;
                  // console.log("prevDayName", prevDayName);
                  const prevActivityGroup =
                    pendingPunches[punchId].activityGroup;
                  if (dayTotals[prevDayName]) {
                    let dayTotalsTemp = { ...dayTotals[prevDayName] };

                    if (
                      prevActivityGroup === "Meal" &&
                      activityGroup === "Meal"
                    ) {
                      console.log("if", mealHours);
                      if (dayName != prevDayName) {
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                        dayTotalsTemp.status = "pending";
                        dayTotals[prevDayName] = dayTotalsTemp;
                      } else {
                        dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                        dayTotalsTemp.mealHours += parseFloat(mealHours);
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.hours += parseFloat(hours);
                        dayTotalsTemp.status = "pending";
                        dayTotals[dayName] = dayTotalsTemp;
                        pendingPunches[punchId].duration = parseFloat(hours);
                        pendingPunches[punchId].dayName = dayName;
                        pendingPunches[punchId].activityGroup = activityGroup;
                        pendingPunches[punchId].jobFamily = jobFamily;
                      }
                    } else if (
                      (prevActivityGroup === "Meal" &&
                        activityGroup != "Meal") ||
                      (prevActivityGroup != "Meal" && activityGroup === "Meal")
                    ) {
                      console.log("else if ");
                      if (
                        prevActivityGroup === "Meal" &&
                        activityGroup != "Meal"
                      ) {
                        if (dayName != prevDayName) {
                          dayTotalsTemp.hours -= parseFloat(prevDuration);
                          dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                          dayTotalsTemp.status = "pending";
                          dayTotals[prevDayName] = dayTotalsTemp;
                        } else {
                          dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                          dayTotalsTemp.hours -= parseFloat(prevDuration);
                          dayTotalsTemp.hours += parseFloat(hours);
                          dayTotalsTemp.activityHours +=
                            parseFloat(activityHours);
                          dayTotalsTemp.status = "pending";
                          dayTotals[dayName] = dayTotalsTemp;
                          pendingPunches[punchId].duration = parseFloat(hours);
                          pendingPunches[punchId].dayName = dayName;
                          pendingPunches[punchId].activityGroup = activityGroup;
                          pendingPunches[punchId].jobFamily = jobFamily;
                        }
                      } else {
                        console.log("else if else ");
                        if (dayName != prevDayName) {
                          dayTotalsTemp.hours -= parseFloat(prevDuration);
                          dayTotalsTemp.activityHours -=
                            parseFloat(prevDuration);
                          dayTotalsTemp.status = "pending";
                          dayTotals[prevDayName] = dayTotalsTemp;
                        } else {
                          dayTotalsTemp.hours -= parseFloat(prevDuration);
                          dayTotalsTemp.activityHours -=
                            parseFloat(prevDuration);
                          dayTotalsTemp.hours += parseFloat(hours);
                          dayTotalsTemp.mealHours += parseFloat(mealHours);
                          dayTotalsTemp.status = "pending";
                          dayTotals[dayName] = dayTotalsTemp;
                          pendingPunches[punchId].duration = parseFloat(hours);
                          pendingPunches[punchId].dayName = dayName;
                          pendingPunches[punchId].activityGroup = activityGroup;
                          pendingPunches[punchId].jobFamily = jobFamily;
                        }
                      }
                    } else {
                      console.log("else");
                      console.log("dayTotalsTemp old ", { ...dayTotalsTemp });
                      if (dayName == prevDayName) {
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                        dayTotalsTemp.hours += parseFloat(hours);
                        dayTotalsTemp.activityHours +=
                          parseFloat(activityHours);
                        dayTotalsTemp.status = "pending";
                        dayTotals[dayName] = dayTotalsTemp;
                        console.log("dayTotalsTemp new ", dayTotalsTemp);
                        pendingPunches[punchId].duration = parseFloat(hours);
                        pendingPunches[punchId].dayName = dayName;
                        pendingPunches[punchId].activityGroup = activityGroup;
                        pendingPunches[punchId].jobFamily = jobFamily;
                      } else {
                        console.log("dayTotalsTemp new else ", dayTotalsTemp);
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                        dayTotalsTemp.status = "pending";
                        dayTotals[prevDayName] = dayTotalsTemp;
                      }
                    }

                    // shifting from one day to other
                    if (dayName != prevDayName) {
                      console.log("shifting scenario", dayName);
                      let dayTot = { ...dayTotals[dayName] };
                      dayTot.activityHours += parseFloat(activityHours);
                      dayTot.mealHours += parseFloat(mealHours);
                      dayTot.hours += parseFloat(hours);
                      dayTot.status = "pending";
                      pendingPunches[punchId] = {
                        duration: parseFloat(hours),
                        dayName: dayName,
                        activityGroup: activityGroup,
                        jobFamily:jobFamily,
                      };
                      dayTotals[dayName] = dayTot;
                    }
                  } else {
                    console.log("epges punch else");
                    dayTotals[dayName].activityHours +=
                      parseFloat(activityHours);
                    dayTotals[dayName].mealHours += parseFloat(mealHours);
                    dayTotals[dayName].hours += parseFloat(hours);
                    dayTotals[dayName].status = "pending";
                    console.log("epges punch else new");
                    pendingPunches[punchId] = {
                      duration: parseFloat(hours),
                      dayName: dayName,
                      activityGroup: activityGroup,
                      jobFamily:jobFamily,
                    };
                  }
                } else if (approvedPunches && approvedPunches[punchId]) {
                  console.log("approved condition");
                  const prevDuration = approvedPunches[punchId].duration;
                  const prevDayName = approvedPunches[punchId].dayName;
                  console.log("prevDayName", prevDayName);
                  const prevActivityGroup =
                    approvedPunches[punchId].activityGroup;

                  let dayTotalsTemp = { ...dayTotals[prevDayName] };

                  if (
                    prevActivityGroup === "Meal" &&
                    activityGroup === "Meal"
                  ) {
                    console.log("if", mealHours);
                    if (dayName != prevDayName) {
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                      dayTotalsTemp.status = "pending";
                      dayTotals[prevDayName] = dayTotalsTemp;
                    } else {
                      dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                      dayTotalsTemp.mealHours += parseFloat(mealHours);
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.hours += parseFloat(hours);
                      dayTotalsTemp.status = "pending";
                      dayTotals[dayName] = dayTotalsTemp;
                    }
                  } else if (
                    (prevActivityGroup === "Meal" && activityGroup != "Meal") ||
                    (prevActivityGroup != "Meal" && activityGroup === "Meal")
                  ) {
                    console.log("else if ");
                    if (
                      prevActivityGroup === "Meal" &&
                      activityGroup != "Meal"
                    ) {
                      if (dayName != prevDayName) {
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                        dayTotalsTemp.status = "pending";
                        dayTotals[prevDayName] = dayTotalsTemp;
                      } else {
                        dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.hours += parseFloat(hours);
                        dayTotalsTemp.activityHours +=
                          parseFloat(activityHours);
                        dayTotalsTemp.status = "pending";
                        dayTotals[dayName] = dayTotalsTemp;
                      }
                    } else {
                      console.log("else if else ");
                      if (dayName != prevDayName) {
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                        dayTotalsTemp.status = "pending";
                        dayTotals[prevDayName] = dayTotalsTemp;
                      } else {
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                        dayTotalsTemp.hours += parseFloat(hours);
                        dayTotalsTemp.mealHours += parseFloat(mealHours);
                        dayTotalsTemp.status = "pending";
                        dayTotals[dayName] = dayTotalsTemp;
                      }
                    }
                  } else {
                    console.log("else");
                    console.log("dayTotalsTemp old ", { ...dayTotalsTemp });
                    if (dayName == prevDayName) {
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                      dayTotalsTemp.hours += parseFloat(hours);
                      dayTotalsTemp.activityHours += parseFloat(activityHours);
                      dayTotalsTemp.status = "pending";
                      dayTotals[dayName] = dayTotalsTemp;
                      console.log("dayTotalsTemp new ", dayTotalsTemp);
                    } else {
                      console.log("dayTotalsTemp new else ", dayTotalsTemp);
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                      dayTotalsTemp.status = "pending";
                      dayTotals[prevDayName] = dayTotalsTemp;
                    }
                  }

                  if (dayName != prevDayName) {
                    console.log("shifting scenario", dayName);
                    console.log("shifting scenario day details ", {
                      ...dayTotalsTemp,
                    });
                    let dayTot = { ...dayTotals[dayName] };
                    console.log("dayTot ", { ...dayTot });
                    dayTot.activityHours += parseFloat(activityHours);
                    dayTot.mealHours += parseFloat(mealHours);
                    dayTot.hours += parseFloat(hours);
                    dayTot.status = "pending";
                    dayTotals[dayName] = dayTot;
                  }

                  delete approvedPunches[punchId];
                  pendingPunches[punchId] = {
                    duration: parseFloat(hours),
                    dayName: dayName,
                    activityGroup: activityGroup,
                    jobFamily:jobFamily,
                  };
                } else {
                  dayTotals[dayName].activityHours += parseFloat(activityHours);
                  dayTotals[dayName].mealHours += parseFloat(mealHours);
                  dayTotals[dayName].hours += parseFloat(hours);
                  dayTotals[dayName].status = "pending";
                  pendingPunches[punchId] = {
                    duration: parseFloat(hours),
                    dayName: dayName,
                    activityGroup: activityGroup,
                    jobFamily:jobFamily,
                  };
                }
              }
            } else {
              console.log("final else:");
              if (deleteFlag) {
                if (pendingPunches && pendingPunches[punchId])
                  delete pendingPunches[punchId];

                if (approvedPunches && approvedPunches[punchId])
                  delete approvedPunches[punchId];
              } else {
                if (pendingPunches && pendingPunches[punchId]) {
                  console.log("pendingPunches", pendingPunches[punchId]);
                  const prevDuration = pendingPunches[punchId].duration;
                  const prevDayName = pendingPunches[punchId].dayName;
                  const prevActivityGroup =
                    pendingPunches[punchId].activityGroup;
                  let dayTotalsTemp = { ...dayTotals[prevDayName] };

                  if (
                    prevActivityGroup === "Meal" &&
                    activityGroup === "Meal"
                  ) {
                    console.log("if", mealHours);
                    dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                    dayTotalsTemp.hours -= parseFloat(prevDuration);
                    dayTotalsTemp.status = "pending";
                    dayTotals[prevDayName] = dayTotalsTemp;
                  } else if (
                    (prevActivityGroup === "Meal" && activityGroup != "Meal") ||
                    (prevActivityGroup != "Meal" && activityGroup === "Meal")
                  ) {
                    console.log("else if ");
                    if (
                      prevActivityGroup === "Meal" &&
                      activityGroup != "Meal"
                    ) {
                      dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.status = "pending";
                      dayTotals[prevDayName] = dayTotalsTemp;
                      pendingPunches[punchId].duration = parseFloat(hours);
                      pendingPunches[punchId].dayName = dayName;
                      pendingPunches[punchId].activityGroup = activityGroup;
                      pendingPunches[punchId].jobFamily = jobFamily;
                    } else {
                      console.log("else if else ");
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                      dayTotalsTemp.status = "pending";
                      dayTotals[prevDayName] = dayTotalsTemp;
                      pendingPunches[punchId].duration = parseFloat(hours);
                      pendingPunches[punchId].dayName = dayName;
                      pendingPunches[punchId].activityGroup = activityGroup;
                      pendingPunches[punchId].jobFamily = jobFamily;
                    }
                  } else {
                    console.log("else");
                    dayTotalsTemp.hours -= parseFloat(prevDuration);
                    dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                    dayTotalsTemp.status = "pending";
                    dayTotals[prevDayName] = dayTotalsTemp;
                  }

                  const dayDataMap = {};
                  dayDataMap["mealHours"] = parseFloat(mealHours);
                  dayDataMap["activityHours"] = parseFloat(activityHours);
                  dayDataMap["hours"] = parseFloat(hours);
                  if (
                    punchStatus === "approved" ||
                    punchStatus === "auto approved" ||
                    punchStatus === "auto adjusted"
                  ) {
                    dayDataMap["status"] = punchStatus;
                  } else {
                    dayDataMap["status"] = "pending";
                  }
                  dayTotals[dayName] = dayDataMap;
                  pendingPunches[punchId] = {
                    duration: parseFloat(hours),
                    dayName: dayName,
                    activityGroup: activityGroup,
                    jobFamily:jobFamily,
                  };
                } else if (approvedPunches && approvedPunches[punchId]) {
                  console.log("approved");
                  const prevDuration = approvedPunches[punchId].duration;
                  const prevDayName = approvedPunches[punchId].dayName;
                  console.log("prevDayName", prevDayName);
                  const prevActivityGroup =
                    approvedPunches[punchId].activityGroup;

                  let dayTotalsTemp = { ...dayTotals[prevDayName] };

                  if (
                    prevActivityGroup === "Meal" &&
                    activityGroup === "Meal"
                  ) {
                    console.log("if", mealHours);
                    if (dayName != prevDayName) {
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                      dayTotalsTemp.status = "pending";
                      dayTotals[prevDayName] = dayTotalsTemp;
                    } else {
                      dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                      dayTotalsTemp.mealHours += parseFloat(mealHours);
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.hours += parseFloat(hours);
                      dayTotalsTemp.status = "pending";
                      dayTotals[dayName] = dayTotalsTemp;
                    }
                  } else if (
                    (prevActivityGroup === "Meal" && activityGroup != "Meal") ||
                    (prevActivityGroup != "Meal" && activityGroup === "Meal")
                  ) {
                    console.log("else if ");
                    if (
                      prevActivityGroup === "Meal" &&
                      activityGroup != "Meal"
                    ) {
                      if (dayName != prevDayName) {
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                        dayTotalsTemp.status = "pending";
                        dayTotals[prevDayName] = dayTotalsTemp;
                      } else {
                        dayTotalsTemp.mealHours -= parseFloat(prevDuration);
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.hours += parseFloat(hours);
                        dayTotalsTemp.activityHours +=
                          parseFloat(activityHours);
                        dayTotalsTemp.status = "pending";
                        dayTotals[dayName] = dayTotalsTemp;
                      }
                    } else {
                      console.log("else if else ");
                      if (dayName != prevDayName) {
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                        dayTotalsTemp.status = "pending";
                        dayTotals[prevDayName] = dayTotalsTemp;
                      } else {
                        dayTotalsTemp.hours -= parseFloat(prevDuration);
                        dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                        dayTotalsTemp.hours += parseFloat(hours);
                        dayTotalsTemp.mealHours += parseFloat(mealHours);
                        dayTotalsTemp.status = "pending";
                        dayTotals[dayName] = dayTotalsTemp;
                      }
                    }
                  } else {
                    console.log("else");
                    if (dayName == prevDayName) {
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                      dayTotalsTemp.hours += parseFloat(hours);
                      dayTotalsTemp.activityHours += parseFloat(activityHours);
                      dayTotalsTemp.status = "pending";
                      dayTotals[dayName] = dayTotalsTemp;
                      console.log("dayTotalsTemp new ", dayTotalsTemp);
                    } else {
                      console.log("dayTotalsTemp new else ", dayTotalsTemp);
                      dayTotalsTemp.hours -= parseFloat(prevDuration);
                      dayTotalsTemp.activityHours -= parseFloat(prevDuration);
                      dayTotalsTemp.status = "pending";
                      dayTotals[prevDayName] = dayTotalsTemp;
                    }
                  }

                  if (dayName != prevDayName) {
                    console.log("shifting scenario", dayName);

                    let dayTot = { ...dayTotals[dayName] };
                    console.log("dayTot ", { ...dayTot });
                    if (dayTot.hours > 0) {
                      dayTot.activityHours += parseFloat(activityHours);
                      dayTot.mealHours += parseFloat(mealHours);
                      dayTot.hours += parseFloat(hours);
                    } else {
                      dayTot.activityHours = parseFloat(activityHours);
                      dayTot.mealHours = parseFloat(mealHours);
                      dayTot.hours = parseFloat(hours);
                    }
                    dayTot.status = "pending";
                    dayTotals[dayName] = dayTot;
                  }

                  delete approvedPunches[punchId];
                  pendingPunches[punchId] = {
                    duration: parseFloat(hours),
                    dayName: dayName,
                    activityGroup: activityGroup,
                    jobFamily:jobFamily,
                  };
                } else {
                  console.log("final else: else");
                  const dayDataMap = {};
                  dayDataMap["mealHours"] = parseFloat(mealHours);
                  dayDataMap["activityHours"] = parseFloat(activityHours);
                  dayDataMap["hours"] = parseFloat(hours);
                  if (
                    punchStatus === "approved" ||
                    punchStatus === "auto approved" ||
                    punchStatus === "auto adjusted"
                  ) {
                    dayDataMap["status"] = punchStatus;
                  } else {
                    dayDataMap["status"] = "pending";
                  }
                  dayTotals[dayName] = dayDataMap;
                  pendingPunches[punchId] = {
                    duration: parseFloat(hours),
                    dayName: dayName,
                    activityGroup: activityGroup,
                    jobFamily:jobFamily,
                  };
                }
              }
            }
            if (pendingPunches) timesheetData.pendingPunches = pendingPunches;
            if (approvedPunches)
              timesheetData.approvedPunches = approvedPunches;
            daysArray = daysArray.filter((c, index) => {
              return daysArray.indexOf(c) === index;
            });

            const dayTotalsMap = {};
            for (let i = 0; i < daysArray.length; i++) {
              const eachDay = daysArray[i];
              console.log("eachDay:", eachDay);
              let weekTotals = { ...dayTotals[eachDay] };
              if (
                weekTotals &&
                (parseFloat(weekTotals["mealHours"]) > 0 ||
                  parseFloat(weekTotals["activityHours"]) > 0 ||
                  parseFloat(weekTotals["hours"]) > 0)
              ) {
                if (weekTotals["mealHours"]) {
                  weekTotals["mealHours"] = parseFloat(
                    weekTotals["mealHours"].toFixed(2)
                  );
                }
                if (weekTotals["activityHours"]) {
                  weekTotals["activityHours"] = parseFloat(
                    weekTotals["activityHours"].toFixed(2)
                  );
                }
                if (weekTotals["hours"]) {
                  weekTotals["hours"] = parseFloat(
                    weekTotals["hours"].toFixed(2)
                  );
                }
                dayTotalsMap[eachDay] = weekTotals;
              }
            }

            if (pendingPunches && pendingPunches[punchId]) {
              let punchDetails = pendingPunches[punchId];
              if (punchDetails.duration <= 0) delete pendingPunches[punchId];
            }
            if (approvedPunches && approvedPunches[punchId]) {
              let punchDetails = approvedPunches[punchId];
              if (punchDetails.duration <= 0) delete approvedPunches[punchId];
            }

            let finalDayTotals = { ...dayTotalsMap };

            if (finalDayTotals) {
              let totalWeekActivityHours = 0.0;
              let totalWeekMealHours = 0.0;
              let totalWeekHours = 0.0;
              for (const eachDayName in finalDayTotals) {
                const eachDayData = finalDayTotals[eachDayName];
                totalWeekActivityHours += eachDayData["activityHours"];
                totalWeekMealHours += eachDayData["mealHours"];
                totalWeekHours += eachDayData["hours"];
              }
              weekTotalHours.activityHours = parseFloat(
                totalWeekActivityHours.toFixed(2)
              );
              weekTotalHours.mealHours = parseFloat(
                totalWeekMealHours.toFixed(2)
              );
              weekTotalHours.hours = parseFloat(totalWeekHours.toFixed(2));
            }
            const actGrpDetailMap={};
            timesheetData.dayTotals = dayTotalsMap;
            let isInprogessAvailable = false;
            if (timesheetData.pendingPunches && Object.keys(timesheetData.pendingPunches).length>0) {
              for (let punchId in timesheetData.pendingPunches) {
                const pendingPunches = timesheetData.pendingPunches[punchId];
                let actGroup = pendingPunches.activityGroup;
                      actGroup =  properCamelCase(actGroup);
                const duration = pendingPunches.duration;
                let jobFamily = pendingPunches.jobFamily;
                const jobFamilyActGrpMap={};
                if (jobFamily) {
                  jobFamily = properCamelCaseNew(jobFamily);
                  if ( jobFamilyDetailMap[jobFamily]) {
                    const jobFamilyDetails =
                            {...jobFamilyDetailMap[jobFamily]};
                    if (jobFamilyDetails[actGroup]) {
                      jobFamilyDetails[actGroup] += duration;
                      jobFamilyDetailMap[jobFamily] =
                              jobFamilyDetails;
                    } else {
                      jobFamilyDetails[actGroup] = duration;
                      jobFamilyDetailMap[jobFamily] =
                              jobFamilyDetails;
                    }
                  } else {
                    jobFamilyActGrpMap[actGroup] = duration;
                    jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                  }
                }

                if (actGroup !='meal') {
                  if ( actGrpDetailMap[actGroup]) {
                    actGrpDetailMap[actGroup] +=duration;
                  } else {
                    actGrpDetailMap[actGroup] =duration;
                  }
                }
                if (duration === 0) {
                  isInprogessAvailable = true;
                  // timesheetData.timesheetStatus = "inProgress";
                }
              }
            }
            if (approvedPunches && Object.keys(approvedPunches).length > 0) {
              for (const punchId in approvedPunches) {
                if (Object.prototype.hasOwnProperty
                    .call(approvedPunches, punchId)) {
                      let actGroup = approvedPunches[punchId]
                      .activityGroup;
                      actGroup =  properCamelCase(actGroup);
                  const duration = approvedPunches[punchId].duration;
                  let jobFamily = approvedPunches[punchId].jobFamily;
                  const jobFamilyActGrpMap={};
                  if (jobFamily) {
                    jobFamily = properCamelCaseNew(jobFamily);
                    if ( jobFamilyDetailMap[jobFamily]) {
                      const jobFamilyDetails =
                              {...jobFamilyDetailMap[jobFamily]};
                      if (jobFamilyDetails[actGroup]) {
                        jobFamilyDetails[actGroup] += duration;
                        jobFamilyDetailMap[jobFamily] =
                                jobFamilyDetails;
                      } else {
                        jobFamilyDetails[actGroup] = duration;
                        jobFamilyDetailMap[jobFamily] =
                                jobFamilyDetails;
                      }
                    } else {
                      jobFamilyActGrpMap[actGroup] = duration;
                      jobFamilyDetailMap[jobFamily] =jobFamilyActGrpMap;
                    }
                  }

                  if (actGroup !='meal') {
                    if ( actGrpDetailMap[actGroup]) {
                      actGrpDetailMap[actGroup] +=duration;
                    } else {
                      actGrpDetailMap[actGroup] =duration;
                    }
                  }
                }
              }
            }

            const activtyGroupTotMap={};
            if (actGrpDetailMap && Object.keys(actGrpDetailMap).length > 0) {
              for (const activityGroup in actGrpDetailMap) {
                if (Object.prototype.hasOwnProperty
                    .call(actGrpDetailMap, activityGroup)) {
                  const duration = actGrpDetailMap[activityGroup];
                  activtyGroupTotMap[activityGroup] =
                parseFloat(duration.toFixed(2));
                }
              }
            }
            const jobFamilyTotMap ={};
            if (Object.keys(jobFamilyDetailMap).length > 0) {
              for (const jobFamily in jobFamilyDetailMap) {
                if (Object.prototype.hasOwnProperty
                    .call(jobFamilyDetailMap, jobFamily)) {
                  const activityGrpMap = jobFamilyDetailMap[jobFamily];
                  for (const activityGroup in activityGrpMap) {
                    if (Object.prototype.hasOwnProperty
                        .call(activityGrpMap, activityGroup)) {
                      const duration = activityGrpMap[activityGroup];
                      activityGrpMap[activityGroup] =
                              parseFloat(duration.toFixed(2));
                      jobFamilyTotMap[jobFamily] = activityGrpMap;
                    }
                  }
                }
              }
            }

            timesheetData.weekTotalHours.activityGroupTotals = activtyGroupTotMap;
            timesheetData.weekTotalHours.jobFamilyTotals = jobFamilyTotMap;
            timesheetData.weekNumber = punch.weekNumber;
            timesheetData.workerId = punch.workerId;
            if (weekTotalHours.hours <= 0 && isInprogessAvailable === false) {
              timesheetData.timesheetStatus = "deleted";
              await timesheetRef
                .update(timesheetData)
                .then((docRef) => {
                  console.log("docRef", docRef);
                  resolve(timesheetData);
                })
                .catch((error) => {
                  reject(error);
                });
            } else {
              await timesheetRef
                .update(timesheetData)
                .then((docRef) => {
                  console.log("docRef", docRef);
                  resolve(timesheetData);
                })
                .catch((error) => {
                  reject(error);
                });
            }

            //resolve(true);
          }
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      console.log("timesheet format error:", error);
      reject(error);
    }
  });
};

export const dayWiseTimesheetApproval = (
  weekNumber,
  workerId,
  approvingDay,
  punches,
  actionBy,
  
   
) => {
  return new Promise(async (resolve, reject) => {
     
    try {
      const docId = weekNumber+'-'+workerId;
      const dayName = moment(approvingDay).format("dddd").toString();
      if (punches) {
        const punchesSize = punches.length;
        if (punchesSize <= 0) {
          console.log("No punches found");
          const error = "No punches found";
          reject(error);
        }
        let batch = db.batch();
        let recordCount = 0;
        const approvedPunchIds = [];
        for (let i = 0; i < punchesSize; i++) {
          let eachPunchRecord = punches[i];
          const punchId = eachPunchRecord.id;
          const punchRef =  punchesRef().doc(punchId);
          await punchRef
          .get()
          .then(async (data) => {
            if (data.exists) {
              if (data.status != "deleted") {
                var punchData = data.data();
                punchData.actionTS = new Date().toISOString();
                punchData.status = "approved";
                punchData.actionBy = actionBy;
                approvedPunchIds.push(punchId);
                batch.set(punchRef, punchData, { merge: true });
                await setPunchHistory(data.id, data.data());
                recordCount++;
              }
            }
          }).catch((error) => {
            console.log(error);
            reject(error);
          });
          
        }
        await batch.commit();
        
        // console.log('approvedPunchIds:', approvedPunchIds);
        if(approvedPunchIds.length<=0){
          const error = 'No punches to approve'
          console.log(error);
            reject(error);
        }
        const timesheetRef = db.collection("timesheets").doc(docId);

        timesheetRef
          .get()
          .then(async (document) => {
            const data = document.data();
            // console.log("data:", data);
            if (data) {

              data.actionTS = new Date().toISOString();
              data.actionBy = actionBy;
              let TSDayTotals = data.dayTotals;
              let dayTotals = TSDayTotals[dayName];
              let pendingPunches = {};
              let approvedPunches = {};
              if (data.pendingPunches)
                pendingPunches = data.pendingPunches;
              if (data.approvedPunches)
                approvedPunches = data.approvedPunches;

                dayTotals.status='approved';
                
              if (pendingPunches) {
                for (let punchId in pendingPunches) {
                  if (Object.prototype.hasOwnProperty.call(pendingPunches,punchId) 
                      && approvedPunchIds.includes(punchId)
                  ) {
                    const punchData = pendingPunches[punchId];
                    approvedPunches[punchId] = punchData;
                    delete(pendingPunches[punchId]);
                  }
                }
              }
              const daysArray = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
              ];


              let pendingCount = 0;
                let inProgressCount = 0;
                if (pendingPunches && Object.keys(pendingPunches).length>0) {
                  for (const eachDay in pendingPunches) {
                    if (pendingPunches[eachDay].duration === 0) {
                      inProgressCount += 1;
                    } else {
                      pendingCount += 1;
                    }
                  }
                }else{
                  for (let i = 0; i < daysArray.length; i++) {
                       const eachDayName = daysArray[i];
                       if(TSDayTotals[eachDayName] && TSDayTotals[eachDayName].status !='approved'){
                        pendingCount += 1;
                       }
                  }
                }
                // console.log('pendingCount:', pendingCount);
                if (pendingCount > 0) {
                  data.timesheetStatus = "pending";
                } else if (inProgressCount > 0) {
                  data.timesheetStatus = "inprogress";
                } else {
                  data.timesheetStatus = "approved";
                }

                await timesheetRef
                .update(data)
                .then((docRef) => {
                  console.log("docRef", docRef);
                  resolve(true);
                })
                .catch((error) => {
                  reject(error);
                });


            }
          });


      }

    }catch (error) {
      console.log("timesheet format error:", error);
      reject(error)
    }
     
    
    
    
  });
};

export const createorUpdateTimeSheetfromPunch = (
  punch,
  actionBy,
  deleteFlag,
  inProgressPunchFlag,
  activityWeekChange,
  oldWeekData
) => {
  return new Promise((resolve, reject) => {
    const { weekNumber, inTS, inLocalTS, outTS, outLocalTS, workerId } = punch;

    const docId = weekNumber + "-" + workerId;

    const timesheetRef = db.collection("timesheets").doc(docId);
    let punchArray = [];
    punchArray.push(punch);

    if (activityWeekChange && oldWeekData) {
      console.log("old timesheet delete");
      const oldWeekNumber = oldWeekData.weekNumber;
      const oldDocId = oldWeekNumber + "-" + workerId;
      console.log("oldDocId:", oldDocId);
      const oldTimesheetRef = db.collection("timesheets").doc(oldDocId);
      oldTimesheetRef.get().then(async (document) => {
        if (document.exists) {
          const data = document.data();
          if (
            data &&
            data.timesheetStatus &&
            data.timesheetStatus != "deleted"
          ) {
            await updateTimesheetfromPunch(
              oldWeekData,
              actionBy,
              true,
              document.id,
              oldWeekData.outLocalTS ? false : true
            )
              .then((result) => {
                console.log("update timesheet result", result);
              })
              .catch((error) => {
                reject(error);
              });
          }
        }
      });
    }
    timesheetRef.get().then(async (document) => {
      if (document.exists) {
        console.log("new timesheet");
        const data = document.data();
        if (data && data.timesheetStatus && data.timesheetStatus != "deleted") {
          await updateTimesheetfromPunch(
            punch,
            actionBy,
            deleteFlag,
            document.id,
            inProgressPunchFlag
          )
            .then((result) => {
              console.log("update timesheet result", result);
              resolve(result);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          if(!deleteFlag){
            await createTimesheetfromPunch(punchArray, actionBy)
            .then((result) => {
              resolve(result);
            })
            .catch((error) => {
              reject(error);
            });
          }else resolve(true);
          
        }
      } else {
        console.log("first else");
        if(!deleteFlag){
          await createTimesheetfromPunch(punchArray, actionBy)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
        }else resolve(true);
        
      }
    });
  });
};
const statusMap = {
  approved: "Approved",
  "auto approved": "Auto Approved",
  "auto completed": "Auto Completed",
  "auto adjusted": "Auto Adjusted",
  edit: "Pending",
  exception: "Exception",
};

export const getStatus = (event) => {
  // console.log("this is event in utils ", event);
  if (!event) return;
  const { status, outLocalTS } = event;
  if (!status) return "Pending";
  if (status == "new" && outLocalTS) return "Pending";
  if (status == "new" && !outLocalTS) return "In Progress";
  return statusMap[status];
};

export const getDurationForEvent = (eventTime) => {
  let a = eventTime.split("-");
  var start = a[0]?.trim();
  let end = a[1]?.trim();
  if (!start) return 0;
  if (!end) return 0;
  if (start.split(":")[0] === "24") {
    let firstStart = "00";
    let endStart = start.split(":")[1];
    start = firstStart + ":" + endStart;
    if (end.split(":")[0] === "24") {
      let firstDate = "00";
      let endDate = end.split(":")[1];
      end = firstDate + ":" + endDate;
    }
  }
  var timeStart = moment(new Date("01/01/2007 " + start));
  var timeEnd = moment(new Date("01/01/2007 " + end));
  var hourDiff = moment.duration(timeEnd.diff(timeStart));
  return hourDiff.asHours().toFixed(2);
};
